const language = {
    'pt':
    {
        see_all_notifications: 'Ver Todas as Notificações',
        tarefas_pendentes: 'Sem tarefas pendentes',
        calendario: 'Calendário',
        abstract: 'Resumo',
        accepted_languages: 'Línguas aceites?',
        accepted: 'Aceite',
        accepted_change: 'Aceite sujeito a alterações',
        access_data: 'Dados de acesso',
        add: 'Adicionar',
        add_author: 'Adicionar autor',
        add_cfp: 'Adicionar CFP',
        add_files: 'Adicionar ficheiro(s)',
        add_files_placeholder: 'Clique aqui para seleccionar os seus ficheiros',
        add_guest: 'Adicionar Convidado',
        add_new: 'Adicionar Novo',
        add_new_tarefa: 'Nova tarefa',
        add_new_appreciation: 'Adicionar uma nova apreciação',
        add_new_appreciation_info_message: 'Para que a sua apreciação seja gravada clique no botão "submeter" e de seguida em "guardar".',
        add_new_cfp: 'Adicionar nova Call for papers',
        add_new_cfp_article_edit_deadline: 'Data limite de edição de artigo',
        add_new_cfp_article_edit_deadline_placeholder: 'Introduza a data limite de edição de artigo',
        add_new_cfp_description_placeholder: 'Introduza a descrição da CFP',
        add_new_cfp_end_date: 'Data limite de fim',
        add_new_cfp_end_date_placeholder: 'Introduza a data limite de fim',
        add_new_cfp_name_placeholder: 'Introduza o nome da CFP',
        add_new_cfp_process_end_date: 'Data de final do processo',
        add_new_cfp_process_end_date_placeholder: 'Introduza a data de final do processo',
        add_new_cfp_rev_fin_dec_date: 'Data da decisão final do revisor',
        add_new_cfp_rev_fin_dec_date_placeholder: 'Introduza a data da decisão final do revisor',
        add_new_cfp_rev_resp_date: 'Data de resposta de revisão',
        add_new_cfp_rev_resp_date_placeholder: 'Introduza a data de resposta de revisão',
        add_new_cfp_start_date: 'Data de início',
        add_new_cfp_start_date_placeholder: 'Introduza a data de início',
        add_new_cfp_submission_date: 'Data de submissão',
        add_new_cfp_submission_date_placeholder: 'Introduza a data de submissão',
        add_new_cfp_sup_mat_deliv_date: 'Data de entrega de material suplementar',
        add_new_cfp_sup_mat_deliv_date_placeholder: 'Introduza data de entrega de material suplementar',
        add_new_cfp_text: 'Para que a sua Call for papers seja gravada clique no botão "Adicionar Cfp" e de seguida em "salvar".',
        add_new_sientific_diffusion_text: 'Escolha a call for papers e em seguida selecione os artigos do mesmo para adicionar na difusão.',
        add_publisher: 'Adicionar Editor',
        add_question: 'Adicionar pergunta',
        add_reviewer: 'Adicionar revisor',
        add_select_articles: 'Adicionar artigo(s) seleccionados',
        add_select_articles_error_message: 'Não seleccionou nenhum artigo!',
        add_select_articles_sucess_message: 'Artigo(s) adicionado(s) com sucesso.',
        add_topic: 'Adicionar Tópico',
        add_topic_error: 'Problema ao atualizar registo!',
        admin: 'Administrador',
        adress: 'Morada',
        affiliation: 'Organização',
        affiliation_insert: 'Introduza a organização',
        appreciations: 'Apreciações',
        article: 'Artigo',
        article_appreciation: 'Apreciação de artigo',
        article_appreciation_view: 'Consultar apreciação do artigo',
        article_final_appreciation: 'Apreciação final do artigo',
        article_code: 'Código do artigo',
        article_edit_deadline: 'Data limite de edição de artigo',
        article_status: 'Estado do artigo',
        article_final_status: 'Estado final do artigo',
        article_submission: 'Submissão de artigo',
        article_submission_limit_message_1: 'Apenas pode submeter',
        article_submission_limit_message_2: 'artigo(s) para esta Call For Papper.',
        article_submission_email_message_1: 'Serve o presente email para o/a notificar que o(a) autor(a) ',
        article_submission_email_message_2: ' submeteu o artigo ',
        article_submission_email_message_3: ' na seguinte data: ',
        article_submission_email_message_4: ' pelas ',
        article_resubmission_email_message_1: 'Serve o presente email para o/a notificar que na sequência da respectiva apreciação o(a) autor(a) ',
        article_resubmission_email_message_2: ' submeteu novamente o artigo ',
        article_resubmission_email_message_3: ' na seguinte data: ',
        article_resubmission_email_message_4: ' pelas ',
        article_review: 'Revisão de artigos',
        articles: 'Artigos',
        articles_approved: 'Total de artigos aprovados',
        articles_assigned: 'Total de artigos atribuídos',
        articles_for_review: 'Total de artigos por rever',
        articles_list: 'Lista de artigos',
        articles_list_view: 'Consultar Lista de Artigos',
        articles_publication_error_message: 'Problema ao atualizar registo do artigo!',
        articles_publication_sucess_message: 'Artigos associados à revista atualizados com sucesso',
        articles_reviewed: 'Total de artigos revistos',
        articles_submission: 'Submissão de artigos',
        articles_submitted: 'Total de artigos submetidos',
        article_title: 'Título do artigo',
        assign_reviewer: 'Atribuir revisor',
        assign_reviewer_confirm_message: 'Tem a certeza que pretende guardar este revisor e enviar a respectiva notificação?',
        assign_reviewers: 'Atribuir revisores',
        assign_reviewers_confirm_message: 'Tem a certeza que pretende guardar este(s) revisores e enviar as respectivas notificações?',
        author: 'Autor',
        author_regist: 'Registo de autor',
        authors: 'Autores',
        authors_list: 'Lista de autores',
        author_question_authorization: 'Os autores têm permissão a ver as perguntas e respostas?',
        automatic_method: 'Automático',
        bibliography: 'Bibliografia',
        biography: 'Biografia',
        cancel: 'Cancelar', back: 'Voltar',
        can_submit_article: 'Pode submeter artigo?',
        cfp_delete_confirm_message: 'Tem a certeza que quer apagar esta difusão?',
        cfp_list: 'Lista de Call For Papers',
        cfp_name: 'Nome da Call for Papers',
        cfp_description: 'Descrição da Call for Papers',
        change_password: 'Alterar password',
        change_password_confirm_message: 'Tem a certeza que pretende alterar a sua password?',
        change_password_error_message: 'Problema ao atualizar password!',
        change_password_required_fields_message: 'Tem que preencher todos os campos relativos à alteração de password',
        change_password_sucess_message: 'Password atualizada com sucesso',
        close: 'Fechar',
        code: 'Código',
        confirmation_password_error_message: 'Password de confirmação diferente da password inserida',
        contact_email:      'Email de contacto',
        contact_recovery:   'Formulário de recuperação',
        contact_restore:    'Formulário de recuperação',
        contacts: 'Contactos',
        content: 'Conteúdo',
        contents_plural: 'Conteúdos',
        contents_plural_list: 'Lista de conteúdos',
        content_insert: 'Inserir conteúdo',
        continuar: 'Continuar',
        choose_file: 'Escolher arquivo',
        conference: 'Conferência',
        country: 'País',
        country_insert: 'Introduza o país',
        current_password: 'Password atual',
        current_password_error_message: 'A password atual está incorreta',
        data_article: 'Dados do artigo',
        data_inicio: 'Data de início',
        data_limite: 'Data limite',
        data_submissao: 'Última atualização',
        date_placeholder: 'Introduza a data',
        dashboard: 'Painel Principal',
        dash_stats_day: 'Hoje',
        dash_stats_last: 'Últimos 7 dias',
        dash_stats_month: 'Mês',
        dash_stats_year: 'Ano',
        delete: 'Eliminar',
        delete_article_confirm_message: 'Tem a certeza que quer apagar este artigo?',
        delete_cfp: 'Deseja eliminar a Tarefa?',
        delete_cfp_cancel: 'Não',
        delete_cfp_confirm: 'Sim',
        delete_cfp_text: 'Pretende mesmo eliminar esta tarefa?',
        delete_confirm: 'Sim',
        delete_cancel: 'Não',
        delete_entity: 'Eliminar Entidade',
        delete_entity_text: 'Tem a certeza que quer apagar esta Entidade?',
        delete_error: 'Problema ao apagar registo!',
        delete_event: 'Tem a certeza que quer apagar este Evento?',
        delete_task: 'Tem a certeza que quer apagar esta tarefa?',
        delete_image: 'Apagar imagem',
        delete_image_confirm_message: 'Tem a certeza que quer apagar esta imagem?',
        delete_image_error_message: 'Não existe nenhuma imagem',
        delete_profile_image: 'Apagar imagem de perfil',
        delete_profile_image_confirm_message: 'Tem a certeza que quer apagar esta imagem de perfil?',
        delete_profile_image_error_message: 'Não existe nenhuma imagem de perfil',
        delete_record: 'Pretende mesmo eliminar este registo?',
        delete_success: 'Registo apagado com sucesso!',
        delete_title: 'Eliminar Registo',
        delete_text: 'Tem a certeza que pretende continuar?',
        description: 'Descrição',
        description_placeholder: 'Introduza a descrição',
        dblpid: 'DBLP ID',
        document_id_recovery:       'Recuperação de credênciais de acesso',
        document_id_recovery_txt:   'Se já é federado mas não sabe as suas credênciais de acesso, insira o seu número de identificação (BI/CC/Autorização de Residência/Passaporte) no campo abaixo.',
        document_id:                '',
        document_id_placeholder:    'Inserir o número do documento de identificação',
        document_id_error:          '',
        edit: 'Editar',
        edit_cancel: 'Não',
        edit_confirm: 'Sim',
        edit_error: 'Problema ao atualizar registo!',
        edit_text: 'Tem a certeza que pretende continuar?',
        edition: 'Edição',
        edition_placeholder: 'Introduza a edição',
        editor_regist: 'Registo de editor',
        email: 'E-mail',
        email_contact: 'E-mail preferencial de contacto',
        email_error_message: 'Campo inválido. Inclua um "@" no endereço de e-mail.',
        email_recover_pass: 'Verifique o seu e-mail.',
        email_recover_pass_2: 'O e-mail não se encontra registado.',
        email_recover_pass_3: 'Este número de documento não tem um e-mail registado.',
        email_recover_pass_4: 'Foram enviadas as instruções a seguir para o email',
        email_recover_pass_5: 'Tenha atenção que o email pode ir para o SPAM.',
        email_register: 'E-mail',
        email_settings: 'Definições de email',
        mobile_phone: 'Número de telemóvel',
        mobile_phone_placeholder: 'Introduza o número de telemóvel',
        end_date: 'Data limite de fim',
        english: 'Inglês',
        error: 'Erro',
        event: 'Evento',
        event_type: 'Tipo de evento',
        events: 'Eventos',
        events_data: 'Dados do Evento',
        events_list: 'Lista de eventos',
        failed_login: 'Falha ao iniciar sessão',
        file_types: 'Tipos de ficheiros?',
        files: 'Ficheiro(s)',
        field_abreviation: 'Abreviatura',
        field_abreviation_placeholder: 'Introduza a abreviação',
        field_description: 'Descrição',
        field_description_placeholder: 'Introduza a descrição',
        field_id: 'ID',
        field_name: 'Nome',
        field_name_placeholder: 'Introduza o nome',
        field_email: 'E-mail',
        field_vat: 'NIF',
        field_date: 'Data',
        field_canhoes: 'Canhões de neve',
        field_status: 'Estado',
        field_comprimento: 'Comprimento',
        field_comprimento_placeholder: 'Inserir comprimento',
        field_dificuldade: 'Dificuldade',
        field_dificuldade_placeholder: 'Inserir dificuldade',
        field_desnivel: 'Desnível (m)',
        field_desnivel_placeholder: 'Inserir desnível (m)',
        field_pagamento_pendente: 'Pagamento',
        field_tem_aula: 'Tem aula',
        field_type: 'Tipo',
        field_hora_levantamento: 'Levantamento',
        field_entrega: 'Entregue',
        field_n_encomenda: 'N.º Encomenda',
        field_total: 'Total',
        french: 'Francês',
        gscholarid: 'Google Scholar ID',
        guests: 'Convidados',
        guest_affiliation: 'Instituição do convidado',
        guest_affiliation_placeholder: 'Introduza a instituição do convidado',
        guest_area: 'Área do convidado',
        guest_area_placeholder: 'Introduza a área do convidado',
        guest_description: 'Descrição do Convidado',
        guest_description_placeholder: 'Introduza a descrição do Convidado',
        guest_name: 'Nome do convidado',
        guest_name_placeholder: 'Introduza o nome do convidado',
        hello: 'Olá',
        home: 'Home',
        id: 'ID',
        identifier: 'Introduza o identificador',
        image: 'Imagem',
        image_choose: 'Escolher imagem',
        in_progress: 'Em curso',
        incorrect_login_data: 'Dados de acesso incorretos',
        incorrect_request: 'Pedido incorreto',
        insert_cancel: 'Não',
        insert_cfp_reqs: 'Tem que preencher o campo do título e da descrição do cfp.',
        insert_confirm: 'Sim',
        insert_diffusion: 'Inserir Difusão',
        insert_error: 'Problema ao inserir registo!',
        insert_event: 'Inserir evento',
        insert_event_cfp_error_message: 'Não inseriu nenhuma Call for Papper associada a este Evento.',
        insert_option: 'Introduza uma opção',
        insert_question: 'Introduza a pergunta',
        insert_text: 'Tem a certeza que pretende continuar?',
        insert_task: 'Inserir Tarefa',
        insert_title: 'Novo Registo',
        insert_url: 'Introduza o URL (endereço)',
        journals_list: 'Lista de revistas',
        keywords: 'Palavras-chave',
        keywords_info: 'Utilize sempre ";" para separar as suas palavras-chave.',
        keywords_insert: 'Introduza as palavras-chave',
        link: 'Link',
        list_publishers: 'Lista de editores',
        loading: 'A carregar',
        magazine: 'Revista',
        magazine_code: 'Código da Revista',
        magazine_conference: 'Revista/Conferência',
        manual: 'Manual',
        materials: 'Materiais',
        max_numb_art_author: 'Número máximo de artigos por autor?',
        max_numb_art_author_placeholder: 'Introduza o número máximo de artigos por autor',
        max_numb_art_reviewer: "Número máximo de artigos por revisor?",
        max_numb_art_reviewer_placeholder: "Introduza o número máximo de artigos por revisor",
        max_numb_rev_per_art: 'Número máximo de revisores por artigo?',
        max_numb_rev_per_art_placeholder: 'Introduza o número máximo de revisores por artigo',
        maximum_submissions_reached: 'máximo de submissões atingido',
        my_data: 'Os meus dados',
        my_tasks: 'As minhas tarefas',
        name: 'Nome',
        name_placeholder: 'Introduza o nome',
        password:   'Password',
        password_placeholder:   'Password',
        new_password: 'Nova password',
        new_password_placeholder: 'Introduza a nova password',
        new_password_2: 'Confirmar password',
        new_password_2_placeholder: 'Confirme a password',
        new_question: 'Nova pergunta',
        new_question_placeholder: 'Introduza uma pergunta',
        new_topic: 'Novo tópico',
        news: 'Notícias 📰',
        no: 'Não',
        no_file_selected: 'Nenhum ficheiro selecionado',
        no_priority: 'Sem Prioridade',
        no_results: 'Sem Registos',
        notifications_error_message: 'Problema ao enviar notificações!',
        notifications_sucess_message: 'Notificações enviadas com sucesso',
        notified: 'Notificado',
        notify: 'Notificar',
        notify_author_button: 'Notificar autor',
        notify_appreciation: 'Notificar apreciação',
        notify_appreciation_error_message: 'Não selecionou um estado final!',
        notify_all: 'Notificar todos',
        notify_author: 'Serve o presente email para o/a notificar que foi atribuído ao seu artigo',
        notify_author_2: 'o estado final',
        notify_message: 'Tem a certeza que pretende atribuir esta apreciação e notificar o autor do respetivo artigo?',
        number: 'Nº',
        observations: 'Observações',
        obs_publisher: 'Observações para o editor',
        orcid: 'ORCID',
        password: 'Palavra-passe',
        password_recover: 'Foi registado um pedido de recuperação da palavra-passe da sua conta.',
        password_recover_2: 'Clique no seguinte link para confirmar o seu pedido e escolher outra palavra-passe:',
        password_recover_3: 'Se não efetuou nenhum pedido, ignore este mail e a sua palavra-passe não será alterada.',

        password_restore: 'Foi registado um pedido de recuperação de acesso da conta',
        password_restore_2: 'Clique no seguinte link para confirmar o seu pedido e escolher uma palavra-passe:',
        password_restore_3: 'Se não efetuou nenhum pedido, ignore este mail e o seu acesso não será alterado.',
        restore_password: 'Recuperar Acesso',

        personal_data: 'Dados Pessoais',
        portuguese: 'Português',
        por_validar: 'por validar ⏳',
        proceedings_list: 'Lista de conferências',
        process_end_date: 'Data de final do processo',
        profile: 'Perfil',
        profile_image: 'Imagem de perfil',
        publication: 'Publicação',
        publication_confirm_message: 'Tem a certeza que pretende publicar esta revista?',
        publication_error_message: 'Problema ao publicar revista!',
        publication_sucess_message: 'Revista publicada com sucesso',
        publication_date: 'Data de publicação',
        publish: 'Publicar',
        publisher: 'Editor',
        publishers: 'Editores',
        published: 'Publicado',
        published_articles: 'Total de artigos publicados',
        published_journals: 'Revistas publicadas',
        publisher_type: 'Tipo de editor',
        question: 'Pergunta',
        questions: 'Perguntas',
        recover_password: 'Recuperar palavra-passe',
        recover_access: 'Recuperar acesso',
        regist_form_sucess_message: 'Resgisto efectuado com sucesso. Verifique os dados de acesso no seu email.',
        regist_form_erro_message: 'Algo correu mal, verifique os seus dados novamente ou contacte a FDI.',
        register_here: 'Registe-se aqui',
        rejected: 'Rejeitado',
        remove: 'Remover',
        remove_all: 'Remover todos',
        remove_article: 'Remover artigo',
        remove_appreciation: 'Remover Apreciação',
        remove_author: 'Remover autor',
        remove_cfp: 'Este Call for Paper está a decorrer. Não pode ser apagado.',
        remove_file: 'Remover ficheiro',
        remove_publisher: 'Remover editor',
        review_type: 'Tipo de Revisão?',
        reviewer: 'Revisor',
        reviewer_assignment: 'Atribuição de Revisor',
        reviewer_assignment_email_message_1: 'Serve o presente email para o/a notificar que lhe foi atribuído o artigo ',
        reviewer_assignment_error_message: 'Não adicionou nenhum revisor!',
        reviewer_regist: 'Registo de Revisor',
        reviewers: 'Revisores',
        reviewers_list: 'Lista de revisores',
        registered_authors: 'Autores inscritos',
        registered_reviewers: 'Revisores inscritos',
        reviewer_attrib_method: 'Tipo de Atribuição a Revisores',
        rev_fin_dec_date: 'Data da decisão final do revisor',
        rev_resp_date: 'Data de resposta de revisão',
        sondagem: 'Sondagens 📈',
        save: 'Guardar',
        scientific_difusion: 'Difusão',
        search: 'Pesquisar',
        see_selected_articles: 'Ver artigos seleccionados',
        select_articles: 'Selecionar artigos',
        select_call_for_paper: 'Selecione a call for paper',
        select_magazine_conference: 'Selecione a revista/conferência',
        select_state_placholder: 'Selecione o estado',
        select_your_files: 'Clique aqui para seleccionar os seus ficheiros',
        selected_item: 'item seleccionado.',
        selected_items: 'items selecionados.',
        spanish: 'Espanhol',
        sscholarid: 'Semantic Scholar ID',
        start_date: 'Data de início',
        status: 'Estado',
        solucao: 'Solução',
        submitted: 'Submetido',
        submitted_application: 'Pedido enviado',
        submission_data: 'Dados de submissão',
        submission_date: 'Data de submissão',
        submission_rules: 'Normas de submissão',
        submission_rules_pdf: 'Ver normas de submissão',
        sup_mat_deliv_date: 'Data de entrega de material suplementar',
        surname: 'Apelido',
        surname_insert: 'Introduza o apelido',
        template: 'Modelo',
        total_cfp: 'Total de call for papers',
        table_all: 'Todos',
        table_date: 'Data',
        table_rows_per_page: 'Registos por página:',
        table_separator: 'de',
        table_title: 'Título',
        table_parent: 'Parent',
        table_actions: 'Acções',
        table_state: 'Estado',
        table_empty: 'sem resultados',
        task_dashboard: 'Dashboard: Análise das Tarefas',
        task_finished: 'Tarefas Concluídas',
        individual: 'Individual',
        coletivo: 'Coletivo',
        task_number: 'Tarefa Nº',
        relatorio: 'Relatório',
        titulo_tarefa: 'Título da Tarefa',
        codigo_tarefa: 'Código da Empresa',
        data_inicio: 'Data Início',
        estado1: 'A Iniciar',
        estado2: 'Em Execução',
        estado3: 'Em Verificação',
        estado4: 'Concluído',
        estado5: 'Cancelado',
        tarefa: 'Tarefas',
        tarefa_acao: 'Ação',
        tarefa_prioridade: 'Prioridade',
        tarefa_empresa: 'Empresa',
        tarefa_estado: 'Estado',
        tarefa_tempo_expiracao: 'Tempo de Expiração',
        tarefa_resp: 'Responsáveis',
        tarefa_respm: 'Monitor',
        tarefa_data: 'Dados das Tarefas',
        tarefa_list: 'Lista de tarefas',
        tarefa_add: 'Adicionar tarefa',
        tarefa_edit: 'Editar tarefa',
        tarefa_new: 'Nova tarefa',
        tarefa_por_expirar: 'Filtrar Por Expirar',
        tarefa_expirados: 'Filtrar Expirados',
        tarefa_validadas: 'Filtrar Validadas',
        tarefa_filtro: 'Filtro',
        tarefa_filtro_concluidos: 'Filtrar Concluídos',
        tarefa_filtro_nao_concluidos: 'Filtrar Nao Concluídos',
        tarefa_acao_placeholder: 'Introduza o título da tarefa',
        tarefa_empresa_placeholder: 'Introduza a referente empresa',
        tarefa_estado_placeholder: 'Introduza o estado da tarefa',
        tarefa_resp_placeholder: 'Responsável/Responsáveis pela tarefa',
        tarefa_respm_placeholder: 'Gestor da tarefa',
        tarefa_prioridade_placeholder: 'Prioridade da tarefa',
        titulo_monitor: 'Tarefas como Monitor',
        titulo_resp: 'Tarefas como Responsável',
        titulo_eDepart: 'Tarefas como Elemento do Grupo/Departamento',

        carregar_responsaveis: 'Carregando responsáveis...',
        validar: 'Validar',
        validar_tarefa: 'Tem a certeza que deseja validar a tarefa?',
        validar_sucesso: 'Tarefa Validada',
        validar_wait: 'Aguarda Validação',
        prioridade_normal: 'Normal',
        prioridade_urgente: 'Urgente',
        prioridade_critico: 'Crítico',
        wait: 'Aguarde enquanto esta tarefa está pendente para validação.',
        departamento: 'Departamentos',
        departamento_responsavel: 'Departamento responsável',
        tarefa_monitor: 'Monitor',
        tarefa_data_solucao: 'Data da Solução',
        tarefa_departamento: 'Departamento',
        tarefa_departamento_placeholder: 'Referente departamento',
        exportar_relatorio: 'Exportar Relatório',
        imprimir_relatorio: 'Imprimir Relatório',
        text: 'Texto',
        title: 'Título',
        title_secondary: 'Título Secundário',
        title_placeholder: 'Introduza o título',
        topic: 'Tópico',
        topics: 'Tópicos',
        type: 'Tipo',
        type_placeholder: 'Introduza o tipo',
        under_review: 'Em revisão',
        unpublished: 'Não publicado',
        unrestricted: 'Sem Restrição',
        upload_file_error: 'Apenas são permitidos ficheiros pdf, doc e docx.\nTamanho máximo: 10MB.\n\n',
        upload_file_types_1: 'Adicionar ficheiro pdf, doc ou docx. Tamanho máximo: 10MB.',
        upload_image_error: 'Apenas são permitidos ficheiros pdf, jpg e png.\nTamanho máximo: 10MB.\n\n',
        user: 'Utilizador',
        username: 'Utilizador',
        username_email: 'Email',
        username_email_insert: 'Introduza o email',
        username_error_message: 'Já existe um registo com este username.',
        username_insert: 'Introduza o utilizador',
        usertype: 'Tipo de utilizador',
        view: 'Ver',
        warning: 'Aviso',
        warning_cfp: 'A Call For Papers tem registos associados. Apenas pode ser editada.',
        web_page: 'Página Web',
        yes: 'Sim',
        validada: 'validada ✅',
        concluida: 'Concluída',
        agree_terms_conditions: 'Concordo com os ',
        agree_rgpd: 'Gostaria de receber informações de interesse sobre a Federação de Desportos de Inverno.',
        cfp_status_closed: 'fechado',
        cfp_status_ending: 'a terminar',
        cfp_status_open: 'aberto',
        cfp_status_soon: 'brevemente',
        content_edit: 'Editar conteúdo',
        content_new: 'Novo conteúdo',
        content_list: 'Lista de conteúdos',
        dates: 'Datas',
        date_creation: 'Criação',
        date_publication: 'Publicação',
        date_last_update: 'Última actualização',
        developed: 'Desenvolvido por',
        discover: 'Descobrir',
        edit_title: 'Editar Registo',
        edit_success: 'Registo actualizado com sucesso!',
        email_placeholder: 'Introduza o email',
        email_error: 'Email incorrecto',
        end: 'Fim',
        enter_country_residence: 'Introduza o país de residência',
        file_attach: 'Attach file',
        file_remove_all: 'Remove all',
        file_upload: 'Upload file',
        file_upload_all: 'Upload all',
        filter_placeholder: 'Procurar',
        form_autor_register: 'Formulário de registo de autor',
        task_sucess: 'Esta tarefa foi validada com sucesso!',
        insert_success: 'Registo inserido com sucesso!',
        learn_more: 'Saber mais',
        location: 'Localização',
        login: 'Iniciar sessão',
        logout: 'Sair',
        multimedia: 'Multimédia',
        message: 'Mensagem',
        message_placeholder: 'Introduza a mensagem',
        organization: 'Organização',
        page_config: 'Configuração da Página',
        page_parent: 'Parent',
        pages: 'Páginas',
        principal: 'Principal',
        privacy_policy: 'Política de privacidade',
        read_terms_conditions: 'Leia os nossos termos e condições antes de submeter o formulário.',
        regist: 'Registo',
        register: 'Registe-se',
        reserved_rights: 'Todos os direitos reservados',
        scientia_magazine: 'Revista Científica',
        search_by_article_name: 'Pesquisa por nome de artigo',
        search_by_author_name: 'Pesquisa por nome de autor',
        search_by_article_keyword: 'Pesquisa por keywords',
        send: 'Enviar',
        seo_config: 'Configuração SEO',
        seo_description: 'Descrição SEO',
        seo_description_placeholder: 'Introduza a descrição SEO',
        seo_keywords: 'Keywords SEO',
        seo_keywords_small: '(separar por virgula)',
        seo_keywords_placeholder: 'Introduza as keywords SEO',
        seo_title: 'Título SEO',
        seo_title_placeholder: 'Introduza o título SEO',
        start: 'Início',
        submission: 'Submissão',
        submit: 'Submeter',
        submit_article: 'Submeter artigo',
        technical_team: 'Corpo técnico',
        terms_conditions: 'Termos e condições',
        terms_conditions_link: 'termos e condições.',
        terms_conditions_required: 'Os campos assinalados com (*) são de preenchimento obrigatório. O endereço de email permite um contacto mais rápido em caso de necessidade de esclarecimentos adicionais. A informação que submeter não será usada ou distribuída por outra razão que não o processamento do seu pedido.',
        notice: 'Tomei conhecimento',
        dash_testimony: 'Testemunhos',
        dash_inscricoes: 'Inscrições em concursos',
        dash_noticias: 'Notícias',
        ok: 'Ok',
        welcome: 'Bem-vindo ',
        last_notification: 'Última notificação',
        birthdays_today: 'Aniversários Hoje',
        today_is_birthday_of: '🥳 Hoje é aniversário de',
        congratulations: 'Parabéns! 🎂',
        main_panel: 'Painel Principal',
        company_news: 'Notícias da Empresa 📰',
        deadline: 'Prazo: ',
        deadlines: 'Prazos ⏳',
        task_dashboard: 'Dashboard: Análise das Tarefas',
        task_priority: 'Prioridade das Tarefas',
        task_status: 'Estado das tarefas',
        completed_tasks: 'Tarefas Concluídas',
        on_time: 'No Prazo',
        delayed: 'Atrasado',
        to_start: 'A Iniciar',
        in_progress: 'Em Execução',
        completed: 'Concluído',
        under_review: 'Em Verificação',
        task_week: 'Tarefas da Semana 📝',
        start_data: 'Data de Início',
        data_realizacao: 'Data de realização',
        due_data: 'Data Limite',
        no_tasks_scheduled: 'Não há tarefas programadas para esta semana no momento.',
        check_back_later: ' Por favor, verifique novamente mais tarde para atualizações ou entre em contato com a equipa responsável.',
        normal: 'Normal',
        urgente: 'Urgente',
        critico: 'Crítico',
        task_resp: 'Responsável pelas Tarefas',
        concluida_antes: 'Concluídas Antes do Prazo',
        concluida_depois: 'Concluídas Após o Prazo',
        total_tarefas: 'Total de tarefas',
        state: 'Estado: ',
        tickets_assistencia: 'Tickets de assistência ',
        calendario_semanal: 'Calendário Semanal',
        sem_nenhum: 'Não tem tickets nem tarefas para o dia selecionado',
        late: 'Atrasado',
        menos_1: 'menos de 1 dia',
        um_dia: '1 dia',
        dois_dias: '2 dias',
        tres_dias: '3 dias',
        quatro_dias: '4 dias',
        cinco_dias: '5 dias',
        seis_dias: '6 dias',
        sete_dias: '7 dias',
        segunda_feira: 'Segunda-feira',
        terca_feira: 'Terça-feira',
        quarta_feira: 'Quarta-feira',
        quinta_feira: 'Quinta-feira',
        sexta_feira: 'Sexta-feira',
        sabado: 'Sábado',
        domingo: 'Domingo',
        sem_tickets: 'Sem tickets para o dia selecionado',
        tarefas_departamento: 'Tarefas departamentais',
        tarefas_por_validar: 'Tarefas por validar',
        tarefas_validada: 'Tarefas Validadas',
        por_submeter: 'Por submeter',
        por_rever: 'Em Revisão',
        task_starting: 'A Iniciar',
        task_in_progress: 'Em Execução',
        task_under_review: 'Em Verificação',
        task_completed: 'Concluído',
        task_cancelled: 'Cancelado',
        numero_tarefas_concluidas: 'Número de Tarefas Concluídas',
        conluida_depois: 'Número de Tarefas Concluídas após o Prazo',
        atrasado: 'Atrasado em',
        dia: 'dia',
        menos_1dia: 'Menos de um dia',
        tarefa_modal: 'Tarefa: ',
        tarefa_calendario: 'Tarefa:',
        stats_of: 'Estatísticas de',
        notifications: 'Notificações',
        notifications_list: 'Todas as Notificações',
        notifications_empty: 'Não existem notificações',

        filtros: 'Filtros',
        restantes: 'Restantes',
        field_choose: 'Escolha uma opção',
        field_clean: 'Limpar Filtros',
        mes: 'Mês',
        ano: 'Ano',
        janeiro: 'Janeiro',
        fevereiro: 'Fevereiro',
        marco: 'Março',
        abril: 'Abril',
        maio: 'Maio',
        junho: 'Junho',
        julho: 'Julho',
        agosto: 'Agosto',
        setembro: 'Setembro',
        outubro: 'Outubro',
        novembro: 'Novembro',
        dezembro: 'Dezembro',
        monitorizacao: 'Monitorização de Consumos',
        consume_tep: 'Consumo em TEP',
        table_conversoes: 'Tabela de Conversões',
        conversões: 'Conversões',
        tep: 'Tep',
        energia: 'Energia',
        average_consume: 'Consumo Médio',
        average_tep: 'Tep Médio',

        consume_mes: 'Consumo por Mês',
        custo_iva_mes: 'Custo com IVA por Mês',
        pie_chart_title: 'Distribuição de TEP por Tipo de Energia',
        bar_chart_title: 'Consumo TEP por Tipo de Energia',
        field_activity_number: 'Número de Atividade',
        add: 'Adicionar',
        add_new: 'Adicionar Evento',
        all: 'Todos',
        calendar: 'Calendário',
        calendar_allday: 'Todo o dia',
        calendar_busy: 'Ocupado',
        calendar_day: 'Dia',
        calendar_daynames: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        calendar_delete: 'Apagar',
        calendar_edit: 'Editar',
        calendar_end_placeholder: 'Data de fim',
        calendar_free: 'Livre',
        calendar_language: 'pt-PT',
        calendar_location_placeholder: 'Localização',
        calendar_month: 'Mês',
        calendar_save: 'Salvar',
        calendar_start_placeholder: 'Data de inicio',
        calendar_title_placeholder: 'Assunto',
        calendar_today: 'Hoje',
        calendar_update: 'Atualizar',
        calendar_viewall: 'Ver tudo',
        calendar_week: 'Semana',
        calendar_year: 'Ano',
        cancel: 'Cancelar',
        category: 'Categoria',
        category_edit: 'Editar categoria',
        category_list: 'Lista de categorias',
        category_new: 'Nova categoria',
        close: 'Fechar',
        color: 'Cor',
        color_placeholder: 'Introduza a cor',
        color_primary: 'Cor Primária',
        color_secondary: 'Cor Secundária',
        component: 'Evento',
        component_edit: 'Editar Evento',
        component_list: 'Lista de Eventos',
        component_new: 'Novo Evento',
        conferencia: 'Conferência',
        critica: 'Crítica',
        date: 'Data de início',
        departamento: 'Departamento',
        departamento_placeholder: 'Seleccione o departamento',
        grupo: 'Grupo',
        grupo_placeholder: 'Seleccione o grupo',
        responsaveis: 'Responsáveis',
        or: 'ou',
        grupo: 'Grupo',
        description: 'Descrição',
        description_placeholder: 'Introduza a descrição',
        disponivel: 'Disponível?',
        edit: 'Editar',
        event_poll: 'Sondagem',
        event_poll_ativar: 'Ativar Sondagem',
        event_poll_bloquear: 'Bloquear Sondagem',
        event_type: 'Tipo de Evento',
        feriado: 'Feriado',
        field_activo: 'Ativo',
        field_available: 'Disponível',
        field_category: 'Categoria',
        field_color: 'Cor',
        field_date: 'Data de início',
        field_description: 'Descrição',
        field_location: 'Localização',
        field_location_placeholder: 'Introduza a localização',
        field_name: 'Nome',
        field_poll_active: 'Ativar Sondagens',
        field_prioridade: 'Prioridade',
        field_select_colab: 'Seleção de Colaboradores',
        field_state: 'Estado',
        field_subtitle: 'Subtítulo',
        field_tag: 'Etiqueta',
        field_time: 'Hora de início',
        field_title: 'Título',
        filtros: 'Filtros',
        filter_placeholder: 'Procurar',
        formacao: 'Formação',
        id: 'ID',
        insert_title: 'Novo Registo',
        location: 'Localização',
        meeting: 'Reunião',
        multipla: 'Múltipla',
        name: 'Nome',
        name_placeholder: 'Introduza o nome',
        nao_urgente: 'Não Urgente',
        no_items: 'Sem itens para mostrar',
        normal: 'Normal',
        other: 'Outro',
        pouco_urgente: 'Pouco Urgente',
        principal: 'Principal',
        remove: 'Remover',
        save: 'Salvar',
        select: 'Selecionar',
        select_placeholder: 'Seleccione o tipo de evento',
        singular: 'Singular',
        tasks: 'Tarefas',
        tasks_on: 'Tarefas em',
        tarefas_agendadas: 'Tarefas Agendadas',
        tarefas_concluidas: 'Tarefas Concluídas',
        tarefas_criadas: 'Tarefas Criadas',
        tarefas_expiradas: 'Tarefas Expiradas',
        table_actions: 'Acções',
        table_all: 'Todos',
        table_date: 'Data',
        table_empty: 'Sem Resultados',
        table_parent: 'Parent',
        table_rows_per_page: 'Registos por página:',
        table_separator: 'de',
        table_state: 'Estado',
        table_title: 'Título',
        tickets: 'Tickets',
        time: 'Hora de início',
        title: 'Título',
        title_placeholder: 'Introduza o título',
        update: 'Atualizar',
        urgente: 'Urgente',
        view: 'Ver',
        video_conferencia: 'Video Conferência',
        votacao: 'Votação',
        votacao_oculta: 'Votação Oculta',
        livre: 'Livre',
        oculta: 'Oculta',
        votes: 'votos',
        workshop: 'Workshop',

        erro: 'Erro',
        sucesso: 'Sucesso',
        adicionar_opcao: 'Adicionar opção?',
        confirmar_opcao: 'Queres mesmo adicionar a opção',
        remover_opcao: 'Remover opção?',
        remover_opcao_placeholder: 'Queres mesmo remover a opção',
        removida: 'Removida!',
        removida_placeholder: 'Opção removida com sucesso!',
        escolha: 'A tua escolha foi registada.',
        adicionada: 'Adicionada!',
        adicionada_placeholder: 'Opção adicionada com sucesso!',
        confirmar_voto: 'Confirmar voto?',
        confirmar_voto_placeholder: 'Queres mesmo votar nesta opção?',
        remover_voto: 'Remover voto?',
        remover_voto_placeholder: 'Queres mesmo remover o teu voto desta opção?',
        votado: 'Votado!',
        delete: 'Eliminar',
        delete_cancel: 'Não',
        delete_confirm: 'Sim',
        delete_error: 'Problema ao apagar registo!',
        delete_success: 'Registo apagado com sucesso!',
        delete_text: 'Tem a certeza que pretende continuar?',
        delete_title: 'Eliminar Registo',
        edit_cancel: 'Não',
        edit_confirm: 'Sim',
        edit_error: 'Problema ao actualizar registo!',
        edit_success: 'Registo actualizado com sucesso!',
        edit_text: 'Tem a certeza que pretende continuar?',
        edit_title: 'Editar Registo',
        insert_cancel: 'Não',
        insert_confirm: 'Sim',
        insert_error: 'Problema ao inserir registo!',
        insert_success: 'Registo inserido com sucesso!',
        insert_text: 'Tem a certeza que pretende continuar?',
        masculino: 'Masculino',
        feminino: 'Feminino',
        outros: 'Outros',
        tipo_identificacao: 'Tipo de identificação',
        numero_identificacao: 'Número de identificação',
        numero_identificacao_placeholder: 'Introduza o número de identificação',
        numero_identificacao_error_message: 'Já existe um registo com esse número de identificação',

        cc: 'Cartão de Cidadão',
        passaporte: 'Passaporte',
        bi: 'Bilhete de Identidade',
        autorizacao_residencia: 'Autorização de Residência',

        old_user_txt_01: 'Caso já tenha sido federado e seja a sua primeira interação com esta nova plataforma da FDI-Portugal, deve pedir para',
        old_user_txt_02: '"Recuperar acesso"',
        old_user_txt_03: 'e seguir as instruções.',
    },

    'en':
    {
        filtros: 'Filters',
        restantes: 'Remaining',
        see_all_notifications: 'See All Notifications',
        titulo_monitor: 'Tasks as Monitor',
        titulo_resp: 'Tasks as Responsible',
        titulo_eDepart: 'Tasks as Group/Department Member',
        task_finished: 'Completed Tasks',
        individual: 'Individual',
        coletivo: 'Collective',
        calendario: 'Calendar',
        tarefa_calendario: 'Task:',
        menos_1dia: 'Less then 1 day',
        atrasado: 'Late in',
        dia: 'day',
        notice: 'I acknowledge.',
        task_starting: 'Starting',
        task_in_progress: 'In Progress',
        task_under_review: 'Under Review',
        task_completed: 'Completed',
        task_cancelled: 'Cancelled',
        por_submeter: 'To submit',
        por_rever: 'In Review',
        tarefas_validada: 'Validated tasks',
        tarefas_por_validar: 'Tasks to validate',
        tarefas_departamento: 'Departmental tasks',
        sem_tickets: 'Without tickets for the selected day',
        sem_nenhum: 'Without tasks or ticket for selected day',
        segunda_feira: 'Monday',
        terca_feira: 'Tuesday',
        quarta_feira: 'Wednesday',
        quinta_feira: 'Thursday',
        sexta_feira: 'Friday',
        sabado: 'Saturday',
        domingo: 'Sunday',
        menos_1: 'less than 1 day',
        um_dia: '1 day',
        dois_dias: '2 days',
        tres_dias: '3 days',
        quatro_dias: '4 days',
        cinco_dias: '5 days',
        seis_dias: '6 days',
        sete_dias: '7 days',
        late: 'Late',
        my_tasks: 'My tasks',
        my_data: 'My data',

        tarefa_filtro: 'Filter',
        calendario_semanal: 'Weekly Calendar ',
        tickets_assistencia: 'Support tickets',
        task_week: 'Tasks of the Current Week 📝',
        data_limite: 'Due Date ',
        state: 'State: ',
        concluida_antes: 'Tasks Completed Beyond the Deadline',
        concluida_depois: 'Tasks Completed Within the Deadline',
        total_tarefas: 'Total tasks',
        data_realizacao: 'Completion Date',
        task_resp: 'Responsible for Tasks',
        abstract: 'Abstract',
        accepted_languages: 'Accepted languages?',
        accepted: 'Accepted',
        accepted_change: 'Accepted subject to change',
        access_data: 'Access data',
        add: 'Add',
        add_author: 'Add author',
        add_cfp: 'Add CFP',
        add_files: 'Add files',
        add_files_placeholder: 'Click here to add files',
        add_guest: 'Add guest',
        add_new: 'Add new',
        add_new_appreciation: 'Add new appreciation',
        add_new_appreciation_info_message: 'For your appreciation to be saved, click on the "submit" button and then "save".',
        add_new_cfp: 'Add new Call for papers',
        add_new_cfp_article_edit_deadline: 'Article edit deadline',
        add_new_cfp_article_edit_deadline_placeholder: 'Insert the article edit deadline',
        add_new_cfp_description_placeholder: 'Insert the description for the CFP',
        add_new_cfp_end_date: 'End date',
        add_new_cfp_end_date_placeholder: 'Insert the end date',
        add_new_cfp_name_placeholder: 'Insert the name of the CFP',
        add_new_cfp_process_end_date: 'Process end date',
        add_new_cfp_process_end_date_placeholder: 'Insert the process end date',
        add_new_cfp_rev_fin_dec_date: 'Date of the reviewer\'s final decision',
        add_new_cfp_rev_fin_dec_date_placeholder: 'Insert the date of the reviewer\'s final decision',
        add_new_cfp_rev_resp_date: 'Review response date',
        add_new_cfp_rev_resp_date_placeholder: 'Insert the review response date',
        add_new_cfp_start_date: 'Start date',
        add_new_cfp_start_date_placeholder: 'Insert the start date',
        add_new_cfp_submission_date: 'Submission date',
        add_new_cfp_submission_date_placeholder: 'Insert the submission date',
        add_new_cfp_sup_mat_deliv_date: 'Supplementary material delivery date',
        add_new_cfp_sup_mat_deliv_date_placeholder: 'Insert the supplementary material delivery date',
        add_new_cfp_text: 'To save the Call for papers click the "Add Cfp" button and then click "save".',
        add_new_sientific_diffusion_text: 'Choose the call for paper and then select the articles from it to add to the dissemination.',
        add_publisher: 'Add publisher',
        add_question: 'Add question',
        add_reviewer: 'Add reviewer',
        add_select_articles: 'Add selected article(s)',
        add_select_articles_error_message: 'No article(s) selected.',
        add_select_articles_sucess_message: 'Article(s) successfully added.',
        add_topic: 'Add Topic',
        admin: 'Admin',
        adress: 'Address',
        start_data: 'Start Date ',
        affiliation: 'Affiliation',
        affiliation_insert: 'Insert the affiliation',
        appreciations: 'Appreciations',
        article: 'Article',
        article_appreciation: 'Article appreciation',
        article_appreciation_view: 'Consult article appreciation',
        article_final_appreciation: 'Final appreciation of the article',
        article_code: 'Article code',
        article_edit_deadline: 'Article edit deadline',
        article_status: 'Article status',
        article_final_status: 'Article final status',
        article_submission: 'Article submission',
        article_submission_limit_message_1: 'You can only submit',
        article_submission_limit_message_2: 'article(s) for this Call For Papper.',
        article_submission_email_message_1: 'This email is used to notify you that the author ',
        article_submission_email_message_2: ' submitted the article ',
        article_submission_email_message_3: ' on the following date: ',
        article_submission_email_message_4: ' by ',
        article_resubmission_email_message_1: 'This email is used to notify you that, following the respective appraisal, the author ',
        article_resubmission_email_message_2: ' resubmitted the article ',
        article_resubmission_email_message_3: ' on the following date: ',
        article_resubmission_email_message_4: ' by ',
        article_title: 'Article title',
        article_review: 'Articles review',
        articles: 'Articles',
        articles_approved: 'Total approved articles',
        articles_assigned: 'Total assigned articles',
        articles_for_review: 'Total articles for review',
        articles_list: 'Articles list',
        articles_list_view: 'View articles list',
        articles_publication_error_message: 'Problem updating article data!',
        articles_publication_sucess_message: 'Articles associated with the magazine successfully updated',
        articles_reviewed: 'Total reviewed articles',
        articles_submission: 'Article Submission',
        articles_submitted: 'Total submitted articles',
        assign_reviewer: 'Assign reviewer',
        assign_reviewer_confirm_message: 'Are you sure you want to save this reviewer and send the corresponding notification?',
        assign_reviewers: 'Assign reviewers',
        assign_reviewers_confirm_message: 'Are you sure you want to save this reviewers and send the corresponding notifications?',
        author: 'Author',
        author_regist: 'Author regist',
        authors: 'Authors',
        authors_list: 'Authors list',
        author_question_authorization: 'Are the authors allowed to see the questions and answers?',
        automatic_method: 'Automatic',
        back: 'Go back',
        bibliography: 'Bibliography',
        biography: 'Biography',
        cancel: 'Cancel',
        can_submit_article: 'Can submit article?',
        cfp_delete_confirm_message: 'Are you sure you want to delete this dissemination?',
        cfp_description: 'Call for Papers description',
        cfp_list: 'Call For Papers List',
        cfp_name: 'Name of the Call for Papers',
        change_password: 'Change password',
        change_password_confirm_message: 'Are you sure you want to change your password?',
        change_password_error_message: 'Problem updating password!',
        change_password_required_fields_message: 'You have to fill in all the fields related to the password change',
        change_password_sucess_message: 'Password updated successfully',
        choose_file: 'Choose file',
        close: 'Close',
        code: 'Code',
        confirmation_password_error_message: 'Confirmation password different from the password entered',
        conference: 'Conference',
        contacts: 'Contacts',
        contact_email: 'Contact Email',
        contact_recovery: 'Recovery form',
        content: 'Contents',  // TODO: content means happy :)
        contents_plural: 'Contents',
        contents_plural_list: 'Contents list',
        content_insert: 'Insert content',
        continuar: 'Continuar',
        country: 'Country',
        country_insert: 'Insert the country',
        current_password: 'Current password',
        current_password_error_message: 'Current password is incorrect',
        dashboard: 'Dashboard',

        dash_stats_day: 'Hoje',
        dash_stats_last: 'Últimos 7 dias',
        dash_stats_month: 'Mês',
        dash_stats_year: 'Ano',
        stats_of: 'Stats of ',
        data_article: 'Data article',
        date_placeholder: 'Insert date',
        delete: 'Delete',
        delete_article_confirm_message: 'Are you sure you want to delete this article?',
        delete_cfp: 'Delete Call For Papers',
        delete_cfp_cancel: 'No',
        delete_cfp_confirm: 'Yes',
        delete_cfp_text: 'Are you sure you want to delete this register?',
        delete_confirm: 'Yes',
        delete_cancel: 'No',
        delete_entity: 'Delete Entity',
        delete_entity_text: 'Are you sure you want to delete this Entity?',
        delete_error: 'Problem deleting the element!',
        delete_event: 'Are you sure you want to delete this Event?',
        delete_image: 'Delete image',
        delete_image_confirm_message: 'Are you sure you want to delete this image?',
        delete_image_error_message: 'There is no image',
        delete_profile_image: 'Delete profile image',
        delete_profile_image_confirm_message: 'Are you sure you want to delete this profile image?',
        delete_profile_image_error_message: 'There is no profile image',
        delete_record: 'Are you sure you want to delete this record?',
        delete_success: 'Element deleted successfully!',
        delete_title: 'Delete Regist',
        delete_text: 'Are you sure you want to continue?',
        dblpid: 'DBLP ID',
        description: 'Description',
        description_placeholder: 'Insert description',
        edit: 'Edit',
        edit_cancel: 'No',
        edit_confirm: 'Yes',
        edit_error: 'Problem updating element!',
        edit_text: 'Are you sure you want to continue?',
        edition: 'Edition',
        edition_placeholder: 'Insert edition',
        editor_regist: 'Editor regist',
        email: 'E-mail',
        email_contact: 'Contact e-mail',
        email_error_message: 'Invalid field. Include an "@" in the email address.',
        email_recover_pass: 'Check your email.',
        email_recover_pass_2: 'E-mail is not registered.',
        email_register: 'Register',
        email_settings: 'E-mail settings',
        mobile_phone: 'Número de telemóvel',
        mobile_phone_placeholder: 'Introduza o número de telemóvel',
        end_date: 'End date',
        english: 'English',
        error: 'Error',
        event: 'Event',
        event_type: 'Event type',
        events_data: 'Events data',
        events: 'Events',
        events_list: 'Events list',
        failed_login: 'Failed login',
        file_types: 'File types?',
        files: 'File(s)',
        field_abreviation: 'Abreviatura',
        field_abreviation_placeholder: 'Introduza a abreviação',
        field_description: 'Descrição',
        field_description_placeholder: 'Introduza a descrição',
        field_id: 'ID',
        field_name: 'Nome',
        field_name_placeholder: 'Introduza o nome',
        field_email: 'E-mail',
        field_vat: 'NIF',
        field_date: 'Data',
        field_canhoes: 'Canhões de neve',
        field_status: 'Estado',
        field_comprimento: 'Comprimento',
        field_comprimento_placeholder: 'Inserir comprimento',
        field_dificuldade: 'Dificuldade',
        field_dificuldade_placeholder: 'Inserir dificuldade',
        field_desnivel: 'Desnível (m)',
        field_desnivel_placeholder: 'Inserir desnível (m)',
        field_pagamento_pendente: 'Pagamento',
        field_tem_aula: 'Tem aula',
        field_type: 'Tipo',
        field_hora_levantamento: 'Levantamento',
        field_entrega: 'Entregue',
        field_n_encomenda: 'N.º Encomenda',
        field_total: 'Total',

        french: 'French',
        gscholarid: 'Google Scholar ID',
        guests: 'Guests',
        guest_affiliation: 'Guest\'s affiliation',
        guest_affiliation_placeholder: 'Insert the guest\'s affiliation',
        guest_area: 'Guest\'s Area ',
        guest_area_placeholder: 'Insert the guest\'s area',
        guest_description: 'Guest\'s description',
        guest_description_placeholder: 'Insert the guest\'s description',
        guest_name: 'Guest\'s name',
        guest_name_placeholder: 'Insert the guest\'s name',
        hello: 'Hello',
        home: 'Home',
        id: 'ID',
        identifier: 'Enter identifier',
        image: 'Image',
        image_choose: 'Choose imagem',
        in_progress: 'In progress',
        incorrect_login_data: 'Incorrect login data',
        incorrect_request: 'Incorrect request',
        insert_cancel: 'No',
        insert_cfp_reqs: 'Must fill in the title and description fields of the CFP.',
        insert_confirm: 'Yes',
        insert_diffusion: 'Insert Dissemination',
        insert_error: 'Problem updating element!',
        insert_event: 'Insert event',
        insert_event_cfp_error_message: 'You have not submited any Call for Paper associated with this Event.',
        insert_option: 'Insert option',
        insert_question: 'Insert the question',
        insert_tarefa: 'Insert task',
        insert_text: 'Are you sure you want to continue?',
        insert_title: 'New Register',
        insert_url: 'Insert the URL',
        journals_list: 'List of journals',
        published_journals: 'Published journals',
        keywords: 'Keywords',
        keywords_info: 'Always use ";" to separate your keywords.',
        keywords_insert: 'Enter your keywords',
        link: 'Link',
        loading: 'Loading',
        magazine: 'Magazine',
        magazine_code: 'Magazine Code',
        magazine_conference: 'Magazine/Conference',
        manual: 'Manual',
        materials: 'Materials',
        max_numb_art_author: 'Maximum number of articles per author?',
        max_numb_art_author_placeholder: 'Insert the maximum number of articles per author',
        max_numb_art_reviewer: "Maximum number of articles per reviewer?",
        max_numb_art_reviewer_placeholder: "Insert the maximum number of articles per reviewer",
        max_numb_rev_per_art: 'Maximum number of reviewers per article?',
        max_numb_rev_per_art_placeholder: 'Insert the maximum number of reviewers per article',
        maximum_submissions_reached: 'maximum submissions reached',
        name: 'Name',
        name_placeholder: 'Insert the name',
        new_password: 'Nova password',
        new_password_placeholder: 'Introduza a nova password',
        new_password_2: 'Confirmar password',
        new_password_2_placeholder: 'Confirme a nova password',
        new_question: 'New question',
        new_question_placeholder: 'Insert a question',
        new_topic: 'New topic',
        no: 'No',
        no_file_selected: 'Nenhum ficheiro selecionado',
        no_results: 'No results',
        notifications_error_message: 'Problem sending notifications!',
        notifications_sucess_message: 'Notifications sent successfully',
        notified: 'Notified',
        notify: 'Notify',
        notify_author_button: 'Notify author',
        notify_appreciation: 'Notify  appreciation',
        notify_appreciation_error_message: 'You did not select a final state!',
        notify_author: 'This email is to notify you that your article',
        notify_author_2: 'has been assigned the final status',
        notify_all: 'Notify all',
        notify_message: 'Are you sure you want to give this appreciation and notify the author of the relevant article?',
        observations: 'Observations',
        obs_publisher: 'Notes for the publisher',
        orcid: 'ORCID',
        password: 'Password',
        password_recover: 'A request to recover your account password has been registered.',
        password_recover_2: 'Click on the following link to confirm your request and choose another password:',
        password_recover_3: 'If you have not made any request, ignore this e-mail and your password will not be changed.',
        personal_data: 'Personal data',
        portuguese: 'Portuguese',
        proceedings_list: 'List of Proceedings',
        process_end_date: 'Process end date',
        profile: 'Profile',
        profile_image: 'Profile image',
        publication: 'Publication',
        publication_confirm_message: 'Are you sure you want to publish this magazine?',
        publication_error_message: 'Problem publishing magazine!',
        publication_sucess_message: 'Magazine successfully published',
        publication_date: 'Publication date',
        publish: 'Publish',
        publisher: 'Publisher',
        publishers: 'Publishers',
        list_publishers: 'Publishers list',
        published: 'Published',
        published_articles: 'Total of published articles',
        publisher_type: 'Tipo de editor',
        question: 'Question',
        questions: 'Questions',
        recover_password: 'Recover password',
        regist_form_sucess_message: 'Registration successful. Check your access data in the email sent.',
        register_here: 'Register here',
        rejected: 'Rejected',
        remove: 'Remove',
        remove_all: 'Remove all',
        remove_article: 'Remove article',
        remove_appreciation: 'Remove appreciation',
        remove_author: 'Remover author',
        remove_cfp: 'This Call for Paper is ongoing. It can\'t be removed',
        remove_file: 'Remove file',
        remove_publisher: 'Remove publisher',
        review_type: 'Review type?',
        reviewer: 'Reviewer',
        reviewer_assignment: 'Reviewer assignment',
        reviewer_assignment_email_message_1: 'This email is used to notify you that the following article has been assigned to you: ',
        reviewer_assignment_error_message: 'Did not add any reviewers!',
        reviewer_regist: 'Reviewer regist',
        reviewer_attrib_method: 'Reviewers attribution method', // Tipo de Atribuição a Revisores
        reviewers: 'Reviewers',
        reviewers_list: 'Reviewers list',
        registered_authors: 'Registered authors',
        registered_reviewers: 'Registered reviewers',
        rev_fin_dec_date: 'Date of the reviewer\'s final decision',
        rev_resp_date: 'Review response date',
        save: 'Save',
        scientific_difusion: 'Dissemination',
        search: 'Search',
        see_selected_articles: 'See select  articles',
        select_articles: 'Select  articles',
        select_call_for_paper: 'Select call for paper',
        select_magazine_conference: 'Select magazine/conference',
        select_state_placholder: 'Select state',
        select_your_files: 'Click here to select your files',
        selected_item: 'selected item.',
        selected_items: 'selected items.',
        spanish: 'Spanish',
        sscholarid: 'Semantic Scholar ID',
        start_date: 'Start date',
        status: 'Status',
        submitted: 'Submitted',
        submitted_application: 'Submitted application',
        submission_data: 'Submission data',
        submission_date: 'Submission date',
        submission_rules: 'Submission rules',
        submission_rules_pdf: 'Open submission rules',
        sup_mat_deliv_date: 'Supplementary material delivery date',
        surname: 'Surname',
        sondagem: 'Polls 📈',
        template: 'Template',
        surname_insert: 'Insert the surname',
        total_cfp: 'Total call for papers',
        table_all: 'All',
        table_date: 'Date',
        table_rows_per_page: 'Records per page:',
        table_separator: 'of',
        table_title: 'Title',

        table_parent: 'Parent',
        table_state: 'State',
        table_actions: 'Actions',

        table_empty: 'sem resultados',

        text: 'Text',
        title: 'Title',
        title_placeholder: 'Insert title',
        title_secondary: 'Secondary title',
        title_secondary_placeholder: 'Insert title',
        topic: 'Topic',
        topics: 'Topics',
        type: 'Type',
        type_placeholder: 'Insert type',
        under_review: 'Under review',
        unpublished: 'Unpublished',
        unrestricted: 'Unrestricted',
        upload_file_error: 'Only pdf, doc and docx files are allowed.\nMaximum size: 10MB.\n\n',
        upload_file_types_1: 'Add pdf, doc or docx file. Maximum size: 10MB.',
        upload_image_error: 'Only pdf, jpg and png files are allowed.\nMaximum size: 10MB.\n\n',
        user: 'User',
        username: 'Username',
        username_email: 'Email',
        username_error_message: 'There is already a record with this username.',
        username_insert: 'Insert the username',
        usertype: 'User Type',
        view: 'View',
        warning: 'Warning',
        warning_cfp: 'The Call For Papers has associated registers. It can only be edited.',
        web_page: 'Web Page',
        welcome: 'Welcome',
        yes: 'Yes',

        /* FRONT */
        agree_terms_conditions: 'I agree to ',
        agree_rgpd: 'I would like to receive information of interest about Federação de Desportos de Inverno.',
        cfp_status_closed: 'closed',
        cfp_status_ending: 'ending',
        cfp_status_open: 'open',
        cfp_status_soon: 'soon',
        content_edit: 'Edit content',
        content_new: 'New content',
        content_list: 'Content list',
        dates: 'Dates',
        date_creation: 'Creation',
        date_publication: 'Publication',
        date_last_update: 'Last update',
        data_submissao: 'Last update',
        developed: 'Developed by',
        discover: 'Discover',
        edit_title: 'Edit Regist',
        edit_success: 'Successful updated element!',
        email_placeholder: 'Insert the email',
        email_error: 'Invalid email address',
        end: 'End',
        enter_country_residence: 'Enter country of residence',
        file_attach: 'Attach file',
        file_remove_all: 'Remove all',
        file_upload: 'Upload file',
        file_upload_all: 'Upload all',
        filter_placeholder: 'Search',
        form_autor_register: 'Author registration form',
        insert_success: 'Successful updated element!',
        learn_more: 'Learn more',
        location: 'Location',
        login: 'Login',
        logout: 'Logout',
        message: 'Message',
        message_placeholder: 'Insert the message',
        multimedia: 'Multimedia',
        organization: 'Organization',
        page_config: 'Page config',
        page_parent: 'Parent',
        pages: 'Pages',
        principal: 'Principal',
        privacy_policy: 'Privacy Policy',
        read_terms_conditions: 'Please read our terms and conditions before submitting the form.',
        regist: 'Register',
        register: 'Register',
        reserved_rights: 'All rights reserved',
        scientia_magazine: 'Scientia Magazine',
        search_by_article_name: 'Search by article name',
        search_by_author_name: 'Search by author name',
        search_by_article_keyword: 'Search by keywords',
        send: 'Send',
        seo_config: 'SEO config',
        seo_description: 'SEO description',
        seo_description_placeholder: 'Insert the SEO description',
        seo_keywords: 'SEO keywords',
        seo_keywords_small: '(separate by comma)',
        seo_keywords_placeholder: 'Insert the SEO keywords',
        seo_title: 'SEO title',
        seo_title_placeholder: 'Insert the SEO title',
        start: 'Start',
        submission: 'Submission',
        submit: 'Submit',
        submit_article: 'Submit article',

        terms_conditions: 'Terms and conditions',
        terms_conditions_link: 'terms and conditions.',
        terms_conditions_required: 'The fields marked with (*) are required. The email address allows for faster contact in the event of further clarification. The information you submit will not be used or distributed for any other reason other than the processing of your request.',
        technical_team: 'Technical team',

        dash_testimony: 'Testimonials',
        dash_inscricoes: 'Contest subscriptions',
        dash_noticias: 'News',
        /// Pagina principal
        main_panel: 'Main Panel',
        news: 'News 📰',
        task_dashboard: 'Dashboard: Task Analysis',
        task_priority: 'Task Priority',
        task_status: 'Task Status',
        completed_tasks: 'Completed Tasks',
        on_time: 'On Time',
        delayed: 'Delayed',
        to_start: 'To Start',
        in_progress: 'In Progress',
        completed: 'Completed',
        under_review: 'Under Review',
        birthdays_today: 'Birthdays Today',
        today_is_birthday_of: '🥳 Today is the birthday of',
        congratulations: 'Congratulations! 🎂',
        deadline: 'Deadline: ',
        deadlines: 'Deadlines ⏳',
        no_tasks_scheduled: 'No tasks are scheduled for this week at the moment.',
        check_back_later: 'Please check back later for updates or contact the responsible team.',
        normal: 'Normal',
        urgente: 'Urgent',
        critico: 'Critical',
        numero_tarefas_concluidas: 'Number of Completed Tasks',
        conluida_depois: 'Number of Tasks Completed After the Deadline',
        tarefa_modal: 'Task: ',
        no_priority: 'No Priority',
        notifications: 'Notifications',
        notifications_list: 'All Notifications',
        notifications_empty: 'There are no notifications',

        field_choose: 'Choose an option',
        field_clean: 'Clear Filters',
        mes: 'Month',
        ano: 'Year',
        janeiro: 'January',
        fevereiro: 'February',
        marco: 'March',
        abril: 'April',
        maio: 'May',
        junho: 'June',
        julho: 'July',
        agosto: 'August',
        setembro: 'September',
        outubro: 'October',
        novembro: 'November',
        dezembro: 'December',
        monitorizacao: 'Consumption Monitoring',
        consume_tep: 'Consumption in TEP',
        table_conversoes: 'Conversion Table',
        conversões: 'Conversions',
        tep: 'Tep',
        energia: 'Energy',
        average_consume: 'Average Consumption',
        average_tep: 'Average Tep',
        consume_mes: 'Consumption by Month',
        custo_iva_mes: 'Cost with VAT by Month',
        pie_chart_title: 'Distribution of TEP by Type of Energy',
        bar_chart_title: 'TEP Consumption by Type of Energy',        
    },
    'es':
    {
        see_all_notifications: 'Ver Todas las Notificaciones',
        tarefas_pendentes: 'Sin tareas pendientes',
        calendario: 'Calendario',
        abstract: 'Resumen',
        accepted_languages: '¿Idiomas aceptados?',
        accepted: 'Aceptado',
        accepted_change: 'Aceptado sujeto a cambios',
        access_data: 'Datos de acceso',
        add: 'Añadir',
        add_author: 'Añadir autor',
        add_cfp: 'Añadir CFP',
        add_files: 'Añadir archivo(s)',
        add_files_placeholder: 'Haga clic aquí para seleccionar sus archivos',
        add_guest: 'Añadir Invitado',
        add_new: 'Añadir Nuevo',
        add_new_tarefa: 'Nueva tarea',
        add_new_appreciation: 'Añadir una nueva apreciación',
        add_new_appreciation_info_message: 'Para que su apreciación sea guardada, haga clic en el botón "enviar" y luego en "guardar".',
        add_new_cfp: 'Añadir nueva Call for papers',
        add_new_cfp_article_edit_deadline: 'Fecha límite de edición de artículo',
        add_new_cfp_article_edit_deadline_placeholder: 'Introduzca la fecha límite de edición de artículo',
        add_new_cfp_description_placeholder: 'Introduzca la descripción de la CFP',
        add_new_cfp_end_date: 'Fecha límite de fin',
        add_new_cfp_end_date_placeholder: 'Introduzca la fecha límite de fin',
        add_new_cfp_name_placeholder: 'Introduzca el nombre de la CFP',
        add_new_cfp_process_end_date: 'Fecha de finalización del proceso',
        add_new_cfp_process_end_date_placeholder: 'Introduzca la fecha de finalización del proceso',
        add_new_cfp_rev_fin_dec_date: 'Fecha de decisión final del revisor',
        add_new_cfp_rev_fin_dec_date_placeholder: 'Introduzca la fecha de decisión final del revisor',
        add_new_cfp_rev_resp_date: 'Fecha de respuesta de revisión',
        add_new_cfp_rev_resp_date_placeholder: 'Introduzca la fecha de respuesta de revisión',
        add_new_cfp_start_date: 'Fecha de inicio',
        add_new_cfp_start_date_placeholder: 'Introduzca la fecha de inicio',
        add_new_cfp_submission_date: 'Fecha de envío',
        add_new_cfp_submission_date_placeholder: 'Introduzca la fecha de envío',
        add_new_cfp_sup_mat_deliv_date: 'Fecha de entrega de material complementario',
        add_new_cfp_sup_mat_deliv_date_placeholder: 'Introduzca la fecha de entrega de material complementario',
        add_new_cfp_text: 'Para que su Call for papers sea guardada, haga clic en el botón "Añadir Cfp" y luego en "guardar".',
        add_new_sientific_diffusion_text: 'Elija la call for papers y luego seleccione los artículos para añadir a la difusión.',
        add_publisher: 'Añadir Editor',
        add_question: 'Añadir pregunta',
        add_reviewer: 'Añadir revisor',
        add_select_articles: 'Añadir artículo(s) seleccionado(s)',
        add_select_articles_error_message: '¡No ha seleccionado ningún artículo!',
        add_select_articles_sucess_message: 'Artículo(s) añadido(s) con éxito.',
        add_topic: 'Añadir Tema',
        add_topic_error: '¡Problema al actualizar el registro!',
        admin: 'Administrador',
        adress: 'Dirección',
        affiliation: 'Organización',
        affiliation_insert: 'Introduzca la organización',
        appreciations: 'Apreciaciones',
        article: 'Artículo',
        article_appreciation: 'Apreciación de artículo',
        article_appreciation_view: 'Consultar apreciación del artículo',
        article_final_appreciation: 'Apreciación final del artículo',
        article_code: 'Código del artículo',
        article_edit_deadline: 'Fecha límite de edición de artículo',
        article_status: 'Estado del artículo',
        article_final_status: 'Estado final del artículo',
        article_submission: 'Envío de artículo',
        article_submission_limit_message_1: 'Solo puede enviar',
        article_submission_limit_message_2: 'artículo(s) para esta Call For Papper.',
        article_submission_email_message_1: 'Este correo electrónico es para notificarle que el autor ',
        article_submission_email_message_2: ' ha enviado el artículo ',
        article_submission_email_message_3: ' en la siguiente fecha: ',
        article_submission_email_message_4: ' a las ',
        article_resubmission_email_message_1: 'Este correo electrónico es para notificarle que, tras la respectiva apreciación, el autor ',
        article_resubmission_email_message_2: ' ha reenviado el artículo ',
        article_resubmission_email_message_3: ' en la siguiente fecha: ',
        article_resubmission_email_message_4: ' a las ',
        article_review: 'Revisión de artículos',
        articles: 'Artículos',
        articles_approved: 'Total de artículos aprobados',
        articles_assigned: 'Total de artículos asignados',
        articles_for_review: 'Total de artículos por revisar',
        articles_list: 'Lista de artículos',
        articles_list_view: 'Consultar Lista de Artículos',
        articles_publication_error_message: '¡Problema al actualizar el registro del artículo!',
        articles_publication_sucess_message: 'Artículos asociados a la revista actualizados con éxito',
        articles_reviewed: 'Total de artículos revisados',
        articles_submission: 'Envío de artículos',
        articles_submitted: 'Total de artículos enviados',
        article_title: 'Título del artículo',
        assign_reviewer: 'Asignar revisor',
        assign_reviewer_confirm_message: '¿Está seguro de que desea guardar este revisor y enviar la respectiva notificación?',
        assign_reviewers: 'Asignar revisores',
        assign_reviewers_confirm_message: '¿Está seguro de que desea guardar este(s) revisor(es) y enviar las respectivas notificaciones?',
        author: 'Autor',
        author_regist: 'Registro de autor',
        authors: 'Autores',
        authors_list: 'Lista de autores',
        author_question_authorization: '¿Los autores tienen permiso para ver las preguntas y respuestas?',
        automatic_method: 'Automático',
        back: 'Volver',
        bibliography: 'Bibliografía',
        biography: 'Biografía',
        cancel: 'Cancelar', back: 'Voltar',
        can_submit_article: '¿Puede enviar artículo?',
        cfp_delete_confirm_message: '¿Está seguro de que quiere eliminar esta difusión?',
        cfp_list: 'Lista de Call For Papers',
        cfp_name: 'Nombre de la Call for Papers',
        cfp_description: 'Descripción de la Call for Papers',
        change_password: 'Cambiar contraseña',
        change_password_confirm_message: '¿Está seguro de que desea cambiar su contraseña?',
        change_password_error_message: '¡Problema al actualizar la contraseña!',
        change_password_required_fields_message: 'Debe completar todos los campos relativos al cambio de contraseña',
        change_password_sucess_message: 'Contraseña actualizada con éxito',
        close: 'Cerrar',
        code: 'Código',
        confirmation_password_error_message: 'La contraseña de confirmación es diferente a la contraseña ingresada',
        contact_email: 'Correo electrónico de contacto',
        contact_recovery: 'Formulario de recuperación',
        contacts: 'Contactos',
        content: 'Contenido',
        contents_plural: 'Contenidos',
        contents_plural_list: 'Lista de contenidos',
        content_insert: 'Insertar contenido',
        continuar: 'Continuar',
        choose_file: 'Elegir archivo',
        conference: 'Conferencia',
        country: 'País',
        country_insert: 'Introduzca el país',
        current_password: 'Contraseña actual',
        current_password_error_message: 'La contraseña actual es incorrecta',
        data_article: 'Datos del artículo',
        data_inicio: 'Fecha de inicio',
        data_limite: 'Fecha límite',
        data_submissao: 'Última actualización',
        date_placeholder: 'Introduzca la fecha',
        dashboard: 'Panel Principal',
        dash_stats_day: 'Hoy',
        dash_stats_last: 'Últimos 7 días',
        dash_stats_month: 'Mes',
        dash_stats_year: 'Año',
        delete: 'Eliminar',
        delete_article_confirm_message: '¿Está seguro de que quiere eliminar este artículo?',
        delete_cfp: '¿Desea eliminar la Tarea?',
        delete_cfp_cancel: 'No',
        delete_cfp_confirm: 'Sí',
        delete_cfp_text: '¿Realmente desea eliminar esta tarea?',
        delete_confirm: 'Sí',
        delete_cancel: 'No',
        delete_entity: 'Eliminar Entidad',
        delete_entity_text: '¿Está seguro de que quiere eliminar esta Entidad?',
        delete_error: '¡Problema al eliminar el registro!',
        delete_event: '¿Está seguro de que quiere eliminar este Evento?',
        delete_task: '¿Está seguro de que quiere eliminar esta tarea?',
        delete_image: 'Eliminar imagen',
        delete_image_confirm_message: '¿Está seguro de que quiere eliminar esta imagen?',
        delete_image_error_message: 'No existe ninguna imagen',
        delete_profile_image: 'Eliminar imagen de perfil',
        delete_profile_image_confirm_message: '¿Está seguro de que quiere eliminar esta imagen de perfil?',
        delete_profile_image_error_message: 'No existe ninguna imagen de perfil',
        delete_record: '¿Realmente desea eliminar este registro?',
        delete_success: '¡Registro eliminado con éxito!',
        delete_title: 'Eliminar Registro',
        delete_text: '¿Está seguro de que desea continuar?',
        description: 'Descripción',
        description_placeholder: 'Introduzca la descripción',
        dblpid: 'DBLP ID',
        edit: 'Editar',
        edit_cancel: 'No',
        edit_confirm: 'Sí',
        edit_error: '¡Problema al actualizar el registro!',
        edit_text: '¿Está seguro de que desea continuar?',
        edition: 'Edición',
        edition_placeholder: 'Introduzca la edición',
        editor_regist: 'Registro de editor',
        email: 'Correo electrónico',
        email_contact: 'Correo electrónico preferido de contacto',
        email_error_message: 'Campo inválido. Incluya un "@" en la dirección de correo electrónico.',
        email_recover_pass: 'Verifique su correo electrónico.',
        email_recover_pass_2: 'El correo electrónico no está registrado.',
        email_register: 'Correo electrónico',
        email_settings: 'Configuración de correo electrónico',
        mobile_phone: 'Número de teléfono móvil',
        mobile_phone_placeholder: 'Introduzca el número de teléfono móvil',
        end_date: 'Fecha límite de fin',
        english: 'Inglés',
        error: 'Error',
        event: 'Evento',
        event_type: 'Tipo de evento',
        events: 'Eventos',
        events_data: 'Datos del Evento',
        events_list: 'Lista de eventos',
        failed_login: 'Error al iniciar sesión',
        file_types: '¿Tipos de archivos?',
        files: 'Archivo(s)',
        field_abreviation: 'Abreviatura',
        field_abreviation_placeholder: 'Introduzca la abreviatura',
        field_description: 'Descripción',
        field_description_placeholder: 'Introduzca la descripción',
        field_id: 'ID',
        field_name: 'Nombre',
        field_name_placeholder: 'Introduzca el nombre',
        field_email: 'Correo electrónico',
        field_vat: 'NIF',
        field_date: 'Fecha',
        field_canhoes: 'Cañones de nieve',
        field_status: 'Estado',
        field_comprimento: 'Longitud',
        field_comprimento_placeholder: 'Inserir longitud',
        field_dificuldade: 'Dificultad',
        field_dificuldade_placeholder: 'Inserir dificultad',
        field_desnivel: 'Desnivel (m)',
        field_desnivel_placeholder: 'Inserir desnivel (m)',
        field_pagamento_pendente: 'Pago',
        field_tem_aula: 'Tiene clase',
        field_type: 'Tipo',
        field_hora_levantamento: 'Recogida',
        field_entrega: 'Entregado',
        field_n_encomenda: 'N.º Pedido',
        field_total: 'Total',
        french: 'Francés',
        gscholarid: 'Google Scholar ID',
        guests: 'Invitados',
        guest_affiliation: 'Institución del invitado',
        guest_affiliation_placeholder: 'Introduzca la institución del invitado',
        guest_area: 'Área del invitado',
        guest_area_placeholder: 'Introduzca el área del invitado',
        guest_description: 'Descripción del Invitado',
        guest_description_placeholder: 'Introduzca la descripción del Invitado',
        guest_name: 'Nombre del invitado',
        guest_name_placeholder: 'Introduzca el nombre del invitado',
        hello: 'Hola',
        home: 'Inicio',
        id: 'ID',
        identifier: 'Introduzca el identificador',
        image: 'Imagen',
        image_choose: 'Elegir imagen',
        in_progress: 'En curso',
        incorrect_login_data: 'Datos de acceso incorrectos',
        incorrect_request: 'Solicitud incorrecta',
        insert_cancel: 'No',
        insert_cfp_reqs: 'Debe completar los campos del título y la descripción del cfp.',
        insert_confirm: 'Sí',
        insert_diffusion: 'Insertar Difusión',
        insert_error: '¡Problema al insertar el registro!',
        insert_event: 'Insertar evento',
        insert_event_cfp_error_message: 'No ha insertado ninguna Call for Papper asociada a este Evento.',
        insert_option: 'Introduzca una opción',
        insert_question: 'Introduzca la pregunta',
        insert_text: '¿Está seguro de que desea continuar?',
        insert_task: 'Insertar Tarea',
        insert_title: 'Nuevo Registro',
        insert_url: 'Introduzca la URL (dirección)',
        journals_list: 'Lista de revistas',
        keywords: 'Palabras clave',
        keywords_info: 'Utilice siempre ";" para separar sus palabras clave.',
        keywords_insert: 'Introduzca las palabras clave',
        link: 'Enlace',
        list_publishers: 'Lista de editores',
        loading: 'Cargando',
        magazine: 'Revista',
        magazine_code: 'Código de la Revista',
        magazine_conference: 'Revista/Conferencia',
        manual: 'Manual',
        materials: 'Materiales',
        max_numb_art_author: '¿Número máximo de artículos por autor?',
        max_numb_art_author_placeholder: 'Introduzca el número máximo de artículos por autor',
        max_numb_art_reviewer: "¿Número máximo de artículos por revisor?",
        max_numb_art_reviewer_placeholder: "Introduzca el número máximo de artículos por revisor",
        max_numb_rev_per_art: '¿Número máximo de revisores por artículo?',
        max_numb_rev_per_art_placeholder: 'Introduzca el número máximo de revisores por artículo',
        maximum_submissions_reached: 'máximo de envíos alcanzado',
        my_data: 'Mis datos',
        my_tasks: 'Mis tareas',
        name: 'Nombre',
        name_placeholder: 'Introduzca el nombre',
        new_password: 'Nueva contraseña',
        new_password_placeholder: 'Introduzca la nueva contraseña',
        new_password_2: 'Confirmar contraseña',
        new_password_2_placeholder: 'Confirme la nueva contraseña',
        new_question: 'Nueva pregunta',
        new_question_placeholder: 'Introduzca una pregunta',
        new_topic: 'Nuevo tema',
        news: 'Noticias 📰',
        no: 'No',
        no_file_selected: 'Ningún archivo seleccionado',
        no_priority: 'Sin Prioridad',
        no_results: 'Sin Registros',
        notifications_error_message: '¡Problema al enviar notificaciones!',
        notifications_sucess_message: 'Notificaciones enviadas con éxito',
        notified: 'Notificado',
        notify: 'Notificar',
        notify_author_button: 'Notificar autor',
        notify_appreciation: 'Notificar apreciación',
        notify_appreciation_error_message: '¡No ha seleccionado un estado final!',
        notify_all: 'Notificar a todos',
        notify_author: 'Este correo electrónico es para notificarle que se le ha asignado a su artículo',
        notify_author_2: 'el estado final',
        notify_message: '¿Está seguro de que desea asignar esta apreciación y notificar al autor del respectivo artículo?',
        number: 'Nº',
        observations: 'Observaciones',
        obs_publisher: 'Observaciones para el editor',
        orcid: 'ORCID',
        password: 'Contraseña',
        password_recover: 'Se ha registrado una solicitud de recuperación de la contraseña de su cuenta.',
        password_recover_2: 'Haga clic en el siguiente enlace para confirmar su solicitud y elegir otra contraseña:',
        password_recover_3: 'Si no ha realizado ninguna solicitud, ignore este correo y su contraseña no será cambiada.',
        personal_data: 'Datos Personales',
        portuguese: 'Portugués',
        por_validar: 'por validar ⏳',
        proceedings_list: 'Lista de conferencias',
        process_end_date: 'Fecha de finalización del proceso',
        profile: 'Perfil',
        profile_image: 'Imagen de perfil',
        publication: 'Publicación',
        publication_confirm_message: '¿Está seguro de que desea publicar esta revista?',
        publication_error_message: '¡Problema al publicar la revista!',
        publication_sucess_message: 'Revista publicada con éxito',
        publication_date: 'Fecha de publicación',
        publish: 'Publicar',
        publisher: 'Editor',
        publishers: 'Editores',
        published: 'Publicado',
        published_articles: 'Total de artículos publicados',
        published_journals: 'Revistas publicadas',
        publisher_type: 'Tipo de editor',
        question: 'Pregunta',
        questions: 'Preguntas',
        recover_password: 'Recuperar contraseña',
        regist_form_sucess_message: 'Registro exitoso. Verifique sus datos de acceso en el correo electrónico enviado.',
        register_here: 'Regístrese aquí',
        rejected: 'Rechazado',
        remove: 'Eliminar',
        remove_all: 'Eliminar todos',
        remove_article: 'Eliminar artículo',
        remove_appreciation: 'Eliminar Apreciación',
        remove_author: 'Eliminar autor',
        remove_cfp: 'Este Call for Paper está en curso. No puede ser eliminado.',
        remove_file: 'Eliminar archivo',
        remove_publisher: 'Eliminar editor',
        review_type: '¿Tipo de Revisión?',
        reviewer: 'Revisor',
        reviewer_assignment: 'Asignación de Revisor',
        reviewer_assignment_email_message_1: 'Este correo electrónico es para notificarle que se le ha asignado el artículo ',
        reviewer_assignment_error_message: '¡No ha añadido ningún revisor!',
        reviewer_regist: 'Registro de Revisor',
        reviewers: 'Revisores',
        reviewers_list: 'Lista de revisores',
        registered_authors: 'Autores registrados',
        registered_reviewers: 'Revisores registrados',
        reviewer_attrib_method: 'Tipo de Asignación a Revisores',
        rev_fin_dec_date: 'Fecha de decisión final del revisor',
        rev_resp_date: 'Fecha de respuesta de revisión',
        sondagem: 'Encuestas 📈',
        save: 'Guardar',
        scientific_difusion: 'Difusión',
        search: 'Buscar',
        see_selected_articles: 'Ver artículos seleccionados',
        select_articles: 'Seleccionar artículos',
        select_call_for_paper: 'Seleccione la call for paper',
        select_magazine_conference: 'Seleccione la revista/conferencia',
        select_state_placholder: 'Seleccione el estado',
        select_your_files: 'Haga clic aquí para seleccionar sus archivos',
        selected_item: 'ítem seleccionado.',
        selected_items: 'ítems seleccionados.',
        spanish: 'Español',
        sscholarid: 'Semantic Scholar ID',
        start_date: 'Fecha de inicio',
        status: 'Estado',
        solucao: 'Solución',
        submitted: 'Enviado',
        submitted_application: 'Solicitud enviada',
        submission_data: 'Datos de envío',
        submission_date: 'Fecha de envío',
        submission_rules: 'Normas de envío',
        submission_rules_pdf: 'Ver normas de envío',
        sup_mat_deliv_date: 'Fecha de entrega de material complementario',
        surname: 'Apellido',
        surname_insert: 'Introduzca el apellido',
        template: 'Modelo',
        total_cfp: 'Total de call for papers',
        table_all: 'Todos',
        table_date: 'Fecha',
        table_rows_per_page: 'Registros por página:',
        table_separator: 'de',
        table_title: 'Título',
        table_parent: 'Parent',
        table_actions: 'Acciones',
        table_state: 'Estado',
        table_empty: 'sin resultados',
        task_dashboard: 'Panel: Análisis de las Tareas',
        task_finished: 'Tareas Concluidas',
        individual: 'Individual',
        coletivo: 'Colectivo',
        task_number: 'Tarea Nº',
        relatorio: 'Informe',
        titulo_tarefa: 'Título de la Tarea',
        codigo_tarefa: 'Código de la Empresa',
        data_inicio: 'Fecha Inicio',
        estado1: 'A Iniciar',
        estado2: 'En Ejecución',
        estado3: 'En Verificación',
        estado4: 'Concluido',
        estado5: 'Cancelado',
        tarefa: 'Tareas',
        tarefa_acao: 'Acción',
        tarefa_prioridade: 'Prioridad',
        tarefa_empresa: 'Empresa',
        tarefa_estado: 'Estado',
        tarefa_tempo_expiracao: 'Tiempo de Expiración',
        tarefa_resp: 'Responsables',
        tarefa_respm: 'Monitor',
        tarefa_data: 'Datos de las Tareas',
        tarefa_list: 'Lista de tareas',
        tarefa_add: 'Añadir tarea',
        tarefa_edit: 'Editar tarea',
        tarefa_new: 'Nueva tarea',
        tarefa_por_expirar: 'Filtrar Por Expirar',
        tarefa_expirados: 'Filtrar Expirados',
        tarefa_validadas: 'Filtrar Validadas',
        tarefa_filtro: 'Filtro',
        tarefa_filtro_concluidos: 'Filtrar Concluidos',
        tarefa_filtro_nao_concluidos: 'Filtrar No Concluidos',
        tarefa_acao_placeholder: 'Introduzca el título de la tarea',
        tarefa_empresa_placeholder: 'Introduzca la empresa correspondiente',
        tarefa_estado_placeholder: 'Introduzca el estado de la tarea',
        tarefa_resp_placeholder: 'Responsable(s) de la tarea',
        tarefa_respm_placeholder: 'Gestor de la tarea',
        tarefa_prioridade_placeholder: 'Prioridad de la tarea',
        titulo_monitor: 'Tareas como Monitor',
        titulo_resp: 'Tareas como Responsable',
        titulo_eDepart: 'Tareas como Miembro del Grupo/Departamento',
        carregar_responsaveis: 'Cargando responsables...',
        validar: 'Validar',
        validar_tarefa: '¿Está seguro de que desea validar la tarea?',
        validar_sucesso: 'Tarea Validada',
        validar_wait: 'Espera Validación',
        prioridade_normal: 'Normal',
        prioridade_urgente: 'Urgente',
        prioridade_critico: 'Crítico',
        wait: 'Espere mientras esta tarea está pendiente para validación.',
        departamento: 'Departamentos',
        departamento_responsavel: 'Departamento responsable',
        tarefa_monitor: 'Monitor',
        tarefa_data_solucao: 'Fecha de la Solución',
        tarefa_departamento: 'Departamento',
        tarefa_departamento_placeholder: 'Departamento correspondiente',
        exportar_relatorio: 'Exportar Informe',
        imprimir_relatorio: 'Imprimir Informe',
        text: 'Texto',
        title: 'Título',
        title_secondary: 'Título Secundario',
        title_placeholder: 'Introduzca el título',
        topic: 'Tema',
        topics: 'Temas',
        type: 'Tipo',
        type_placeholder: 'Introduzca el tipo',
        under_review: 'En revisión',
        unpublished: 'No publicado',
        unrestricted: 'Sin Restricción',
        upload_file_error: 'Solo se permiten archivos pdf, doc y docx.\nTamaño máximo: 10MB.\n\n',
        upload_file_types_1: 'Añadir archivo pdf, doc o docx. Tamaño máximo: 10MB.',
        upload_image_error: 'Solo se permiten archivos pdf, jpg y png.\nTamaño máximo: 10MB.\n\n',
        user: 'Usuario',
        username: 'Usuario',
        username_email: 'Correo electrónico',
        username_error_message: 'Ya existe un registro con este nombre de usuario.',
        username_insert: 'Introduzca el usuario',
        usertype: 'Tipo de usuario',
        view: 'Ver',
        warning: 'Advertencia',
        warning_cfp: 'La Call For Papers tiene registros asociados. Solo puede ser editada.',
        web_page: 'Página Web',
        yes: 'Sí',
        validada: 'validada ✅',
        concluida: 'Concluida',
        agree_terms_conditions: 'Acepto los ',
        agree_rgpd: 'Me gustaría recibir información de interés sobre Federação de Desportos de Inverno.',
        cfp_status_closed: 'cerrado',
        cfp_status_ending: 'a terminar',
        cfp_status_open: 'abierto',
        cfp_status_soon: 'próximamente',
        content_edit: 'Editar contenido',
        content_new: 'Nuevo contenido',
        content_list: 'Lista de contenidos',
        dates: 'Fechas',
        date_creation: 'Creación',
        date_publication: 'Publicación',
        date_last_update: 'Última actualización',
        developed: 'Desarrollado por',
        discover: 'Descubrir',
        edit_title: 'Editar Registro',
        edit_success: '¡Registro actualizado con éxito!',
        email_placeholder: 'Introduzca el correo electrónico',
        email_error: 'Correo electrónico incorrecto',
        end: 'Fin',
        enter_country_residence: 'Introduzca el país de residencia',
        file_attach: 'Adjuntar archivo',
        file_remove_all: 'Eliminar todos',
        file_upload: 'Subir archivo',
        file_upload_all: 'Subir todos',
        filter_placeholder: 'Buscar',
        form_autor_register: 'Formulario de registro de autor',
        task_sucess: '¡Esta tarea ha sido validada con éxito!',
        insert_success: '¡Registro insertado con éxito!',
        learn_more: 'Saber más',
        location: 'Ubicación',
        login: 'Iniciar sesión',
        logout: 'Salir',
        multimedia: 'Multimedia',
        message: 'Mensaje',
        message_placeholder: 'Introduzca el mensaje',
        organization: 'Organización',
        page_config: 'Configuración de la Página',
        page_parent: 'Parent',
        pages: 'Páginas',
        principal: 'Principal',
        privacy_policy: 'Política de privacidad',
        read_terms_conditions: 'Lea nuestros términos y condiciones antes de enviar el formulario.',
        regist: 'Registro',
        register: 'Regístrese',
        reserved_rights: 'Todos los derechos reservados',
        scientia_magazine: 'Revista Científica',
        search_by_article_name: 'Búsqueda por nombre de artículo',
        search_by_author_name: 'Búsqueda por nombre de autor',
        search_by_article_keyword: 'Búsqueda por palabras clave',
        send: 'Enviar',
        seo_config: 'Configuración SEO',
        seo_description: 'Descripción SEO',
        seo_description_placeholder: 'Introduzca la descripción SEO',
        seo_keywords: 'Palabras clave SEO',
        seo_keywords_small: '(separar por coma)',
        seo_keywords_placeholder: 'Introduzca las palabras clave SEO',
        seo_title: 'Título SEO',
        seo_title_placeholder: 'Introduzca el título SEO',
        start: 'Inicio',
        submission: 'Envío',
        submit: 'Enviar',
        submit_article: 'Enviar artículo',
        technical_team: 'Cuerpo técnico',
        terms_conditions: 'Términos y condiciones',
        terms_conditions_link: 'términos y condiciones.',
        terms_conditions_required: 'Los campos marcados con (*) son de cumplimentación obligatoria. La dirección de correo electrónico permite un contacto más rápido en caso de necesidad de aclaraciones adicionales. La información que envíe no será utilizada o distribuida por otra razón que no sea el procesamiento de su solicitud.',
        notice: 'Tomo conocimiento',
        dash_testimony: 'Testimonios',
        dash_inscricoes: 'Inscripciones en concursos',
        dash_noticias: 'Noticias',
        ok: 'Ok',
        welcome: 'Bienvenido ',
        last_notification: 'Última notificación',
        birthdays_today: 'Cumpleaños Hoy',
        today_is_birthday_of: '🥳 Hoy es el cumpleaños de',
        congratulations: '¡Felicitaciones! 🎂',
        main_panel: 'Panel Principal',
        company_news: 'Noticias de la Empresa 📰',
        deadline: 'Plazo: ',
        deadlines: 'Plazos ⏳',
        task_dashboard: 'Panel: Análisis de las Tareas',
        task_priority: 'Prioridad de las Tareas',
        task_status: 'Estado de las tareas',
        completed_tasks: 'Tareas Concluidas',
        on_time: 'A Tiempo',
        delayed: 'Retrasado',
        to_start: 'A Iniciar',
        in_progress: 'En Ejecución',
        completed: 'Concluido',
        under_review: 'En Verificación',
        task_week: 'Tareas de la Semana 📝',
        start_data: 'Fecha de Inicio',
        data_realizacao: 'Fecha de realización',
        due_data: 'Fecha Límite',
        no_tasks_scheduled: 'No hay tareas programadas para esta semana en este momento.',
        check_back_later: ' Por favor, verifique nuevamente más tarde para actualizaciones o póngase en contacto con el equipo responsable.',
        normal: 'Normal',
        urgente: 'Urgente',
        critico: 'Crítico',
        task_resp: 'Responsable de las Tareas',
        concluida_antes: 'Concluidas Antes del Plazo',
        concluida_depois: 'Concluidas Después del Plazo',
        total_tarefas: 'Total de tareas',
        state: 'Estado: ',
        tickets_assistencia: 'Tickets de asistencia ',
        calendario_semanal: 'Calendario Semanal',
        sem_nenhum: 'No tiene tickets ni tareas para el día seleccionado',
        late: 'Retrasado',
        menos_1: 'menos de 1 día',
        um_dia: '1 día',
        dois_dias: '2 días',
        tres_dias: '3 días',
        quatro_dias: '4 días',
        cinco_dias: '5 días',
        seis_dias: '6 días',
        sete_dias: '7 días',
        segunda_feira: 'Lunes',
        terca_feira: 'Martes',
        quarta_feira: 'Miércoles',
        quinta_feira: 'Jueves',
        sexta_feira: 'Viernes',
        sabado: 'Sábado',
        domingo: 'Domingo',
        sem_tickets: 'Sin tickets para el día seleccionado',
        tarefas_departamento: 'Tareas departamentales',
        tarefas_por_validar: 'Tareas por validar',
        tarefas_validada: 'Tareas Validadas',
        por_submeter: 'Por enviar',
        por_rever: 'En Revisión',
        task_starting: 'A Iniciar',
        task_in_progress: 'En Ejecución',
        task_under_review: 'En Verificación',
        task_completed: 'Concluido',
        task_cancelled: 'Cancelado',
        numero_tarefas_concluidas: 'Número de Tareas Concluidas',
        conluida_depois: 'Número de Tareas Concluidas después del Plazo',
        atrasado: 'Retrasado en',
        dia: 'día',
        menos_1dia: 'Menos de un día',
        tarefa_modal: 'Tarea: ',
        tarefa_calendario: 'Tarea:',
        stats_of: 'Estadísticas de',
        notifications: 'Notificaciones',
        notifications_list: 'Todas las Notificaciones',
        notifications_empty: 'No hay notificaciones',
        masculino: 'Masculino',
        feminino: 'Femenino',
        outros: 'Otros',

    }, 'fr': {
        see_all_notifications: 'Voir toutes les notifications',
        tarefas_pendentes: 'Aucune tâche en attente',
        calendario: 'Calendrier',
        abstract: 'Résumé',
        accepted_languages: 'Langues acceptées ?',
        accepted: 'Accepté',
        accepted_change: 'Accepté sous réserve de modifications',
        access_data: 'Données d\'accès',
        add: 'Ajouter',
        add_author: 'Ajouter un auteur',
        add_cfp: 'Ajouter CFP',
        add_files: 'Ajouter fichier(s)',
        add_files_placeholder: 'Cliquez ici pour sélectionner vos fichiers',
        add_guest: 'Ajouter un invité',
        add_new: 'Ajouter nouveau',
        add_new_tarefa: 'Nouvelle tâche',
        add_new_appreciation: 'Ajouter une nouvelle appréciation',
        add_new_appreciation_info_message: 'Pour enregistrer votre appréciation, cliquez sur le bouton "soumettre" puis sur "enregistrer".',
        add_new_cfp: 'Ajouter une nouvelle Call for papers',
        add_new_cfp_article_edit_deadline: 'Date limite de modification de l\'article',
        add_new_cfp_article_edit_deadline_placeholder: 'Entrez la date limite de modification de l\'article',
        add_new_cfp_description_placeholder: 'Entrez la description de la CFP',
        add_new_cfp_end_date: 'Date limite de fin',
        add_new_cfp_end_date_placeholder: 'Entrez la date limite de fin',
        add_new_cfp_name_placeholder: 'Entrez le nom de la CFP',
        add_new_cfp_process_end_date: 'Date de fin du processus',
        add_new_cfp_process_end_date_placeholder: 'Entrez la date de fin du processus',
        add_new_cfp_rev_fin_dec_date: 'Date de décision finale du relecteur',
        add_new_cfp_rev_fin_dec_date_placeholder: 'Entrez la date de décision finale du relecteur',
        add_new_cfp_rev_resp_date: 'Date de réponse de relecture',
        add_new_cfp_rev_resp_date_placeholder: 'Entrez la date de réponse de relecture',
        add_new_cfp_start_date: 'Date de début',
        add_new_cfp_start_date_placeholder: 'Entrez la date de début',
        add_new_cfp_submission_date: 'Date de soumission',
        add_new_cfp_submission_date_placeholder: 'Entrez la date de soumission',
        add_new_cfp_sup_mat_deliv_date: 'Date de livraison du matériel supplémentaire',
        add_new_cfp_sup_mat_deliv_date_placeholder: 'Entrez la date de livraison du matériel supplémentaire',
        add_new_cfp_text: 'Pour enregistrer votre Call for papers, cliquez sur le bouton "Ajouter Cfp" puis sur "enregistrer".',
        add_new_sientific_diffusion_text: 'Choisissez la call for papers puis sélectionnez les articles à ajouter à la diffusion.',
        add_publisher: 'Ajouter un éditeur',
        add_question: 'Ajouter une question',
        add_reviewer: 'Ajouter un relecteur',
        add_select_articles: 'Ajouter article(s) sélectionné(s)',
        add_select_articles_error_message: 'Vous n\'avez sélectionné aucun article !',
        add_select_articles_sucess_message: 'Article(s) ajouté(s) avec succès.',
        add_topic: 'Ajouter un sujet',
        add_topic_error: 'Problème lors de la mise à jour de l\'enregistrement !',
        admin: 'Administrateur',
        adress: 'Adresse',
        affiliation: 'Organisation',
        affiliation_insert: 'Entrez l\'organisation',
        appreciations: 'Appréciations',
        article: 'Article',
        article_appreciation: 'Appréciation d\'article',
        article_appreciation_view: 'Consulter l\'appréciation de l\'article',
        article_final_appreciation: 'Appréciation finale de l\'article',
        article_code: 'Code de l\'article',
        article_edit_deadline: 'Date limite de modification de l\'article',
        article_status: 'État de l\'article',
        article_final_status: 'État final de l\'article',
        article_submission: 'Soumission d\'article',
        article_submission_limit_message_1: 'Vous ne pouvez soumettre que',
        article_submission_limit_message_2: 'article(s) pour cette Call For Papper.',
        article_submission_email_message_1: 'Cet email a pour but de vous notifier que l\'auteur ',
        article_submission_email_message_2: ' a soumis l\'article ',
        article_submission_email_message_3: ' à la date suivante : ',
        article_submission_email_message_4: ' à ',
        article_resubmission_email_message_1: 'Cet email a pour but de vous notifier qu\'à la suite de l\'appréciation respective, l\'auteur ',
        article_resubmission_email_message_2: ' a resoumis l\'article ',
        article_resubmission_email_message_3: ' à la date suivante : ',
        article_resubmission_email_message_4: ' à ',
        article_review: 'Relecture d\'articles',
        articles: 'Articles',
        articles_approved: 'Total d\'articles approuvés',
        articles_assigned: 'Total d\'articles attribués',
        articles_for_review: 'Total d\'articles à relire',
        articles_list: 'Liste d\'articles',
        articles_list_view: 'Consulter la liste des articles',
        articles_publication_error_message: 'Problème lors de la mise à jour de l\'enregistrement de l\'article !',
        articles_publication_sucess_message: 'Articles associés à la revue mis à jour avec succès',
        articles_reviewed: 'Total d\'articles relus',
        articles_submission: 'Soumission d\'articles',
        articles_submitted: 'Total d\'articles soumis',
        article_title: 'Titre de l\'article',
        assign_reviewer: 'Attribuer un relecteur',
        assign_reviewer_confirm_message: 'Êtes-vous sûr de vouloir enregistrer ce relecteur et envoyer la notification correspondante ?',
        assign_reviewers: 'Attribuer des relecteurs',
        assign_reviewers_confirm_message: 'Êtes-vous sûr de vouloir enregistrer ce(s) relecteur(s) et envoyer les notifications correspondantes ?',
        author: 'Auteur',
        author_regist: 'Enregistrement d\'auteur',
        authors: 'Auteurs',
        authors_list: 'Liste d\'auteurs',
        author_question_authorization: 'Les auteurs ont-ils l\'autorisation de voir les questions et réponses ?',
        automatic_method: 'Automatique',
        back: 'Retour',
        bibliography: 'Bibliographie',
        biography: 'Biographie',
        cancel: 'Annuler',
        can_submit_article: 'Peut soumettre un article ?',
        cfp_delete_confirm_message: 'Êtes-vous sûr de vouloir supprimer cette diffusion ?',
        cfp_list: 'Liste des Call For Papers',
        cfp_name: 'Nom de la Call for Papers',
        cfp_description: 'Description de la Call for Papers',
        change_password: 'Changer le mot de passe',
        change_password_confirm_message: 'Êtes-vous sûr de vouloir changer votre mot de passe ?',
        change_password_error_message: 'Problème lors de la mise à jour du mot de passe !',
        change_password_required_fields_message: 'Vous devez remplir tous les champs relatifs au changement de mot de passe',
        change_password_sucess_message: 'Mot de passe mis à jour avec succès',
        close: 'Fermer',
        code: 'Code',
        confirmation_password_error_message: 'Le mot de passe de confirmation est différent du mot de passe saisi',
        contact_email: 'Email de contact',
        contact_recovery: 'Formulaire de récupération',
        contacts: 'Contacts',
        content: 'Contenu',
        contents_plural: 'Contenus',
        contents_plural_list: 'Liste de contenus',
        content_insert: 'Insérer du contenu',
        continuar: 'Continuer',
        choose_file: 'Choisir un fichier',
        conference: 'Conférence',
        country: 'Pays',
        country_insert: 'Entrez le pays',
        current_password: 'Mot de passe actuel',
        current_password_error_message: 'Le mot de passe actuel est incorrect',
        data_article: 'Données de l\'article',
        data_inicio: 'Date de début',
        data_limite: 'Date limite',
        data_submissao: 'Dernière mise à jour',
        date_placeholder: 'Entrez la date',
        dashboard: 'Tableau de bord principal',
        dash_stats_day: 'Aujourd\'hui',
        dash_stats_last: '7 derniers jours',
        dash_stats_month: 'Mois',
        dash_stats_year: 'Année',
        delete: 'Supprimer',
        delete_article_confirm_message: 'Êtes-vous sûr de vouloir supprimer cet article ?',
        delete_cfp: 'Voulez-vous supprimer la tâche ?',
        delete_cfp_cancel: 'Non',
        delete_cfp_confirm: 'Oui',
        delete_cfp_text: 'Voulez-vous vraiment supprimer cette tâche ?',
        delete_confirm: 'Oui',
        delete_cancel: 'Non',
        delete_entity: 'Supprimer l\'entité',
        delete_entity_text: 'Êtes-vous sûr de vouloir supprimer cette entité ?',
        delete_error: 'Problème lors de la suppression de l\'enregistrement !',
        delete_event: 'Êtes-vous sûr de vouloir supprimer cet événement ?',
        delete_task: 'Êtes-vous sûr de vouloir supprimer cette tâche ?',
        delete_image: 'Supprimer l\'image',
        delete_image_confirm_message: 'Êtes-vous sûr de vouloir supprimer cette image ?',
        delete_image_error_message: 'Il n\'y a aucune image',
        delete_profile_image: 'Supprimer l\'image de profil',
        delete_profile_image_confirm_message: 'Êtes-vous sûr de vouloir supprimer cette image de profil ?',
        delete_profile_image_error_message: 'Il n\'y a aucune image de profil',
        delete_record: 'Voulez-vous vraiment supprimer cet enregistrement ?',
        delete_success: 'Enregistrement supprimé avec succès !',
        delete_title: 'Supprimer l\'enregistrement',
        delete_text: 'Êtes-vous sûr de vouloir continuer ?',
        dblpid: 'DBLP ID',
        description: 'Description',
        description_placeholder: 'Entrez la description',
        edit: 'Modifier',
        edit_cancel: 'Non',
        edit_confirm: 'Oui',
        edit_error: 'Problème lors de la mise à jour de l\'enregistrement !',
        edit_text: 'Êtes-vous sûr de vouloir continuer ?',
        edition: 'Édition',
        edition_placeholder: 'Entrez l\'édition',
        editor_regist: 'Enregistrement d\'éditeur',
        email: 'E-mail',
        email_contact: 'E-mail de contact préféré',
        email_error_message: 'Champ invalide. Incluez un "@" dans l\'adresse e-mail.',
        email_recover_pass: 'Vérifiez votre e-mail.',
        email_recover_pass_2: 'L\'e-mail n\'est pas enregistré.',
        email_register: 'E-mail',
        email_settings: 'Paramètres d\'e-mail',
        mobile_phone: 'Numéro de portable',
        mobile_phone_placeholder: 'Entrez le numéro de portable',
        end_date: 'Date limite de fin',
        english: 'Anglais',
        error: 'Erreur',
        event: 'Événement',
        event_type: 'Type d\'événement',
        events: 'Événements',
        events_data: 'Données de l\'événement',
        events_list: 'Liste d\'événements',
        failed_login: 'Échec de la connexion',
        file_types: 'Types de fichiers ?',
        files: 'Fichier(s)',
        field_abreviation: 'Abréviation',
        field_abreviation_placeholder: 'Entrez l\'abréviation',
        field_description: 'Description',
        field_description_placeholder: 'Entrez la description',
        field_id: 'ID',
        field_name: 'Nom',
        field_name_placeholder: 'Entrez le nom',
        field_email: 'E-mail',
        field_vat: 'NIF',
        field_date: 'Date',
        field_canhoes: 'Canons à neige',
        field_status: 'État',
        field_comprimento: 'Longueur',
        field_comprimento_placeholder: 'Entrez la longueur',
        field_dificuldade: 'Difficulté',
        field_dificuldade_placeholder: 'Entrez la difficulté',
        field_desnivel: 'Dénivelé (m)',
        field_desnivel_placeholder: 'Entrez le dénivelé (m)',
        field_pagamento_pendente: 'Paiement',
        field_tem_aula: 'A une leçon',
        field_type: 'Type',
        field_hora_levantamento: 'Prise',
        field_entrega: 'Livré',
        field_n_encomenda: 'N.º Commande',
        field_total: 'Total',
        french: 'Français',
        gscholarid: 'Google Scholar ID',
        guests: 'Invités',
        guest_affiliation: 'Institution de l\'invité',
        guest_affiliation_placeholder: 'Entrez l\'institution de l\'invité',
        guest_area: 'Domaine de l\'invité',
        guest_area_placeholder: 'Entrez le domaine de l\'invité',
        guest_description: 'Description de l\'invité',
        guest_description_placeholder: 'Entrez la description de l\'invité',
        guest_name: 'Nom de l\'invité',
        guest_name_placeholder: 'Entrez le nom de l\'invité',
        hello: 'Bonjour',
        home: 'Accueil',
        id: 'ID',
        identifier: 'Entrez l\'identifiant',
        image: 'Image',
        image_choose: 'Choisir une image',
        in_progress: 'En cours',
        incorrect_login_data: 'Données de connexion incorrectes',
        incorrect_request: 'Demande incorrecte',
        insert_cancel: 'Non',
        insert_cfp_reqs: 'Vous devez remplir les champs du titre et de la description du cfp.',
        insert_confirm: 'Oui',
        insert_diffusion: 'Insérer une diffusion',
        insert_error: 'Problème lors de l\'insertion de l\'enregistrement !',
        insert_event: 'Insérer un événement',
        insert_event_cfp_error_message: 'Vous n\'avez inséré aucune Call for Papper associée à cet événement.',
        insert_option: 'Entrez une option',
        insert_question: 'Entrez la question',
        insert_text: 'Êtes-vous sûr de vouloir continuer ?',
        insert_task: 'Insérer une tâche',
        insert_title: 'Nouvel enregistrement',
        insert_url: 'Entrez l\'URL (adresse)',
        journals_list: 'Liste des revues',
        keywords: 'Mots-clés',
        keywords_info: 'Utilisez toujours ";" pour séparer vos mots-clés.',
        keywords_insert: 'Entrez les mots-clés',
        link: 'Lien',
        list_publishers: 'Liste des éditeurs',
        loading: 'Chargement',
        magazine: 'Revue',
        magazine_code: 'Code de la revue',
        magazine_conference: 'Revue/Conférence',
        manual: 'Manuel',
        materials: 'Matériaux',
        max_numb_art_author: 'Nombre maximum d\'articles par auteur ?',
        max_numb_art_author_placeholder: 'Entrez le nombre maximum d\'articles par auteur',
        max_numb_art_reviewer: "Nombre maximum d\'articles par relecteur ?",
        max_numb_art_reviewer_placeholder: "Entrez le nombre maximum d\'articles par relecteur",
        max_numb_rev_per_art: 'Nombre maximum de relecteurs par article ?',
        max_numb_rev_per_art_placeholder: 'Entrez le nombre maximum de relecteurs par article',
        maximum_submissions_reached: 'nombre maximum de soumissions atteint',
        my_data: 'Mes données',
        my_tasks: 'Mes tâches',
        name: 'Nom',
        name_placeholder: 'Entrez le nom',
        new_password: 'Nouveau mot de passe',
        new_password_placeholder: 'Entrez le nouveau mot de passe',
        new_password_2: 'Confirmer le mot de passe',
        new_password_2_placeholder: 'Confirmez le nouveau mot de passe',
        new_question: 'Nouvelle question',
        new_question_placeholder: 'Entrez une question',
        new_topic: 'Nouveau sujet',
        news: 'Actualités 📰',
        no: 'Non',
        no_file_selected: 'Aucun fichier sélectionné',
        no_priority: 'Aucune priorité',
        no_results: 'Aucun enregistrement',
        notifications_error_message: 'Problème lors de l\'envoi des notifications !',
        notifications_sucess_message: 'Notifications envoyées avec succès',
        notified: 'Notifié',
        notify: 'Notifier',
        notify_author_button: 'Notifier l\'auteur',
        notify_appreciation: 'Notifier l\'appréciation',
        notify_appreciation_error_message: 'Vous n\'avez pas sélectionné d\'état final !',
        notify_all: 'Notifier tous',
        notify_author: 'Cet e-mail a pour but de vous notifier que l\'état final',
        notify_author_2: 'a été attribué à votre article',
        notify_message: 'Êtes-vous sûr de vouloir attribuer cette appréciation et notifier l\'auteur de l\'article concerné ?',
        number: 'Nº',
        observations: 'Observations',
        obs_publisher: 'Remarques pour l\'éditeur',
        orcid: 'ORCID',
        password: 'Mot de passe',
        password_recover: 'Une demande de récupération du mot de passe de votre compte a été enregistrée.',
        password_recover_2: 'Cliquez sur le lien suivant pour confirmer votre demande et choisir un autre mot de passe :',
        password_recover_3: 'Si vous n\'avez effectué aucune demande, ignorez cet e-mail et votre mot de passe ne sera pas modifié.',
        personal_data: 'Données personnelles',
        portuguese: 'Portugais',
        por_validar: 'à valider ⏳',
        proceedings_list: 'Liste des conférences',
        process_end_date: 'Date de fin du processus',
        profile: 'Profil',
        profile_image: 'Image de profil',
        publication: 'Publication',
        publication_confirm_message: 'Êtes-vous sûr de vouloir publier cette revue ?',
        publication_error_message: 'Problème lors de la publication de la revue !',
        publication_sucess_message: 'Revue publiée avec succès',
        publication_date: 'Date de publication',
        publish: 'Publier',
        publisher: 'Éditeur',
        publishers: 'Éditeurs',
        published: 'Publié',
        published_articles: 'Total d\'articles publiés',
        published_journals: 'Revues publiées',
        publisher_type: 'Type d\'éditeur',
        question: 'Question',
        questions: 'Questions',
        recover_password: 'Récupérer le mot de passe',
        regist_form_sucess_message: 'Enregistrement réussi. Vérifiez vos données d\'accès dans l\'e-mail envoyé.',
        register_here: 'Inscrivez-vous ici',
        rejected: 'Rejeté',
        remove: 'Supprimer',
        remove_all: 'Supprimer tous',
        remove_article: 'Supprimer l\'article',
        remove_appreciation: 'Supprimer l\'appréciation',
        remove_author: 'Supprimer l\'auteur',
        remove_cfp: 'Cette Call for Paper est en cours. Elle ne peut pas être supprimée.',
        remove_file: 'Supprimer le fichier',
        remove_publisher: 'Supprimer l\'éditeur',
        review_type: 'Type de relecture ?',
        reviewer: 'Relecteur',
        reviewer_assignment: 'Attribution de relecteur',
        reviewer_assignment_email_message_1: 'Cet e-mail a pour but de vous notifier que l\'article ',
        reviewer_assignment_error_message: 'Vous n\'avez ajouté aucun relecteur !',
        reviewer_regist: 'Enregistrement de relecteur',
        reviewers: 'Relecteurs',
        reviewers_list: 'Liste de relecteurs',
        registered_authors: 'Auteurs enregistrés',
        registered_reviewers: 'Relecteurs enregistrés',
        reviewer_attrib_method: 'Méthode d\'attribution des relecteurs',
        rev_fin_dec_date: 'Date de décision finale du relecteur',
        rev_resp_date: 'Date de réponse de relecture',
        sondagem: 'Sondages 📈',
        save: 'Enregistrer',
        scientific_difusion: 'Diffusion',
        search: 'Rechercher',
        see_selected_articles: 'Voir les articles sélectionnés',
        select_articles: 'Sélectionner des articles',
        select_call_for_paper: 'Sélectionnez la call for paper',
        select_magazine_conference: 'Sélectionnez la revue/conférence',
        select_state_placholder: 'Sélectionnez l\'état',
        select_your_files: 'Cliquez ici pour sélectionner vos fichiers',
        selected_item: 'élément sélectionné.',
        selected_items: 'éléments sélectionnés.',
        spanish: 'Espagnol',
        sscholarid: 'Semantic Scholar ID',
        start_date: 'Date de début',
        status: 'État',
        solucao: 'Solution',
        submitted: 'Soumis',
        submitted_application: 'Demande soumise',
        submission_data: 'Données de soumission',
        submission_date: 'Date de soumission',
        submission_rules: 'Règles de soumission',
        submission_rules_pdf: 'Voir les règles de soumission',
        sup_mat_deliv_date: 'Date de livraison du matériel supplémentaire',
        surname: 'Nom de famille',
        surname_insert: 'Entrez le nom de famille',
        template: 'Modèle',
        total_cfp: 'Total des call for papers',
        table_all: 'Tous',
        table_date: 'Date',
        table_rows_per_page: 'Enregistrements par page :',
        table_separator: 'de',
        table_title: 'Titre',
        table_parent: 'Parent',
        table_actions: 'Actions',
        table_state: 'État',
        table_empty: 'aucun résultat',
        task_dashboard: 'Tableau de bord : Analyse des tâches',
        task_finished: 'Tâches terminées',
        individual: 'Individuel',
        coletivo: 'Collectif',
        task_number: 'Tâche Nº',
        relatorio: 'Rapport',
        titulo_tarefa: 'Titre de la tâche',
        codigo_tarefa: 'Code de l\'entreprise',
        data_inicio: 'Date de début',
        estado1: 'À démarrer',
        estado2: 'En cours',
        estado3: 'En vérification',
        estado4: 'Terminé',
        estado5: 'Annulé',
        tarefa: 'Tâches',
        tarefa_acao: 'Action',
        tarefa_prioridade: 'Priorité',
        tarefa_empresa: 'Entreprise',
        tarefa_estado: 'État',
        tarefa_tempo_expiracao: 'Temps d\'expiration',
        tarefa_resp: 'Responsables',
        tarefa_respm: 'Moniteur',
        tarefa_data: 'Données des tâches',
        tarefa_list: 'Liste des tâches',
        tarefa_add: 'Ajouter une tâche',
        tarefa_edit: 'Modifier une tâche',
        tarefa_new: 'Nouvelle tâche',
        tarefa_por_expirar: 'Filtrer Par Expiration',
        tarefa_expirados: 'Filtrer Expirés',
        tarefa_validadas: 'Filtrer Validées',
        tarefa_filtro: 'Filtre',
        tarefa_filtro_concluidos: 'Filtrer Terminés',
        tarefa_filtro_nao_concluidos: 'Filtrer Non Terminés',
        tarefa_acao_placeholder: 'Entrez le titre de la tâche',
        tarefa_empresa_placeholder: 'Entrez l\'entreprise concernée',
        tarefa_estado_placeholder: 'Entrez l\'état de la tâche',
        tarefa_resp_placeholder: 'Responsable(s) de la tâche',
        tarefa_respm_placeholder: 'Gestionnaire de la tâche',
        tarefa_prioridade_placeholder: 'Priorité de la tâche',
        titulo_monitor: 'Tâches en tant que Moniteur',
        titulo_resp: 'Tâches en tant que Responsable',
        titulo_eDepart: 'Tâches en tant que Membre du Groupe/Département',
        carregar_responsaveis: 'Chargement des responsables...',
        validar: 'Valider',
        validar_tarefa: 'Êtes-vous sûr de vouloir valider la tâche ?',
        validar_sucesso: 'Tâche validée',
        validar_wait: 'En attente de validation',
        prioridade_normal: 'Normal',
        prioridade_urgente: 'Urgent',
        prioridade_critico: 'Critique',
        wait: 'Veuillez patienter pendant que cette tâche est en attente de validation.',
        departamento: 'Départements',
        departamento_responsavel: 'Département responsable',
        tarefa_monitor: 'Moniteur',
        tarefa_data_solucao: 'Date de la solution',
        tarefa_departamento: 'Département',
        tarefa_departamento_placeholder: 'Département concerné',
        exportar_relatorio: 'Exporter le rapport',
        imprimir_relatorio: 'Imprimer le rapport',
        text: 'Texte',
        title: 'Titre',
        title_secondary: 'Titre secondaire',
        title_placeholder: 'Entrez le titre',
        topic: 'Sujet',
        topics: 'Sujets',
        type: 'Type',
        type_placeholder: 'Entrez le type',
        under_review: 'En révision',
        unpublished: 'Non publié',
        unrestricted: 'Sans restriction',
        upload_file_error: 'Seuls les fichiers pdf, doc et docx sont autorisés.\nTaille maximale : 10MB.\n\n',
        upload_file_types_1: 'Ajouter un fichier pdf, doc ou docx. Taille maximale : 10MB.',
        upload_image_error: 'Seuls les fichiers pdf, jpg et png sont autorisés.\nTaille maximale : 10MB.\n\n',
        user: 'Utilisateur',
        username: 'Utilisateur',
        username_email: 'Email',
        username_error_message: 'Il existe déjà un enregistrement avec ce nom d\'utilisateur.',
        username_insert: 'Entrez l\'utilisateur',
        usertype: 'Type d\'utilisateur',
        view: 'Voir',
        warning: 'Avertissement',
        warning_cfp: 'La Call For Papers a des enregistrements associés. Elle ne peut être que modifiée.',
        web_page: 'Page Web',
        yes: 'Oui',
        validada: 'validée ✅',
        concluida: 'Terminée',
        agree_terms_conditions: 'J\'accepte les ',
        agree_rgpd: 'Je souhaite recevoir des informations d\'intérêt sur Federação de Desportos de Inverno.',
        cfp_status_closed: 'fermé',
        cfp_status_ending: 'en fin',
        cfp_status_open: 'ouvert',
        cfp_status_soon: 'bientôt',
        content_edit: 'Modifier le contenu',
        content_new: 'Nouveau contenu',
        content_list: 'Liste de contenus',
        dates: 'Dates',
        date_creation: 'Création',
        date_publication: 'Publication',
        date_last_update: 'Dernière mise à jour',
        developed: 'Développé par',
        discover: 'Découvrir',
        edit_title: 'Modifier l\'enregistrement',
        edit_success: 'Enregistrement mis à jour avec succès !',
        email_placeholder: 'Entrez l\'e-mail',
        email_error: 'E-mail incorrect',
        end: 'Fin',
        enter_country_residence: 'Entrez le pays de résidence',
        file_attach: 'Joindre un fichier',
        file_remove_all: 'Supprimer tout',
        file_upload: 'Télécharger un fichier',
        file_upload_all: 'Télécharger tout',
        filter_placeholder: 'Rechercher',
        form_autor_register: 'Formulaire d\'enregistrement d\'auteur',
        task_sucess: 'Cette tâche a été validée avec succès !',
        insert_success: 'Enregistrement inséré avec succès !',
        learn_more: 'En savoir plus',
        location: 'Localisation',
        login: 'Se connecter',
        logout: 'Se déconnecter',
        multimedia: 'Multimédia',
        message: 'Message',
        message_placeholder: 'Entrez le message',
        organization: 'Organisation',
        page_config: 'Configuration de la page',
        page_parent: 'Parent',
        pages: 'Pages',
        principal: 'Principal',
        privacy_policy: 'Politique de confidentialité',
        read_terms_conditions: 'Veuillez lire nos termes et conditions avant de soumettre le formulaire.',
        regist: 'Enregistrement',
        register: 'Inscrivez-vous',
        reserved_rights: 'Tous droits réservés',
        scientia_magazine: 'Revue Scientifique',
        search_by_article_name: 'Recherche par nom d\'article',
        search_by_author_name: 'Recherche par nom d\'auteur',
        search_by_article_keyword: 'Recherche par mots-clés',
        send: 'Envoyer',
        seo_config: 'Configuration SEO',
        seo_description: 'Description SEO',
        seo_description_placeholder: 'Entrez la description SEO',
        seo_keywords: 'Mots-clés SEO',
        seo_keywords_small: '(séparer par virgule)',
        seo_keywords_placeholder: 'Entrez les mots-clés SEO',
        seo_title: 'Titre SEO',
        seo_title_placeholder: 'Entrez le titre SEO',
        start: 'Début',
        submission: 'Soumission',
        submit: 'Soumettre',
        submit_article: 'Soumettre un article',
        technical_team: 'Équipe technique',
        terms_conditions: 'Termes et conditions',
        terms_conditions_link: 'termes et conditions.',
        terms_conditions_required: 'Les champs marqués d\'un (*) sont obligatoires. L\'adresse e-mail permet un contact plus rapide en cas de besoin d\'éclaircissements supplémentaires. Les informations que vous soumettez ne seront pas utilisées ou distribuées pour une autre raison que le traitement de votre demande.',
        notice: 'Je prends connaissance',
        dash_testimony: 'Témoignages',
        dash_inscricoes: 'Inscriptions aux concours',
        dash_noticias: 'Actualités',
        ok: 'Ok',
        welcome: 'Bienvenue ',
        last_notification: 'Dernière notification',
        birthdays_today: 'Anniversaires Aujourd\'hui',
        today_is_birthday_of: '🥳 Aujourd\'hui c\'est l\'anniversaire de',
        congratulations: 'Félicitations ! 🎂',
        main_panel: 'Tableau de bord principal',
        company_news: 'Actualités de l\'entreprise 📰',
        deadline: 'Échéance : ',
        deadlines: 'Échéances ⏳',
        task_dashboard: 'Tableau de bord : Analyse des tâches',
        task_priority: 'Priorité des tâches',
        task_status: 'État des tâches',
        completed_tasks: 'Tâches terminées',
        on_time: 'À temps',
        delayed: 'En retard',
        to_start: 'À démarrer',
        in_progress: 'En cours',
        completed: 'Terminé',
        under_review: 'En vérification',
        task_week: 'Tâches de la semaine 📝',
        start_data: 'Date de début',
        data_realizacao: 'Date de réalisation',
        due_data: 'Date limite',
        no_tasks_scheduled: 'Aucune tâche n\'est programmée pour cette semaine pour le moment.',
        check_back_later: 'Veuillez vérifier plus tard pour des mises à jour ou contactez l\'équipe responsable.',
        normal: 'Normal',
        urgente: 'Urgent',
        critico: 'Critique',
        task_resp: 'Responsable des tâches',
        concluida_antes: 'Terminées avant l\'échéance',
        concluida_depois: 'Terminées après l\'échéance',
        total_tarefas: 'Total des tâches',
        state: 'État : ',
        tickets_assistencia: 'Tickets d\'assistance ',
        calendario_semanal: 'Calendrier hebdomadaire',
        sem_nenhum: 'Vous n\'avez pas de tickets ni de tâches pour le jour sélectionné',
        late: 'En retard',
        menos_1: 'moins d\'1 jour',
        um_dia: '1 jour',
        dois_dias: '2 jours',
        tres_dias: '3 jours',
        quatro_dias: '4 jours',
        cinco_dias: '5 jours',
        seis_dias: '6 jours',
        sete_dias: '7 jours',
        segunda_feira: 'Lundi',
        terca_feira: 'Mardi',
        quarta_feira: 'Mercredi',
        quinta_feira: 'Jeudi',
        sexta_feira: 'Vendredi',
        sabado: 'Samedi',
        domingo: 'Dimanche',
        sem_tickets: 'Aucun ticket pour le jour sélectionné',
        tarefas_departamento: 'Tâches départementales',
        tarefas_por_validar: 'Tâches à valider',
        tarefas_validada: 'Tâches validées',
        por_submeter: 'À soumettre',
        por_rever: 'En révision',
        task_starting: 'À démarrer',
        task_in_progress: 'En cours',
        task_under_review: 'En vérification',
        task_completed: 'Terminé',
        task_cancelled: 'Annulé',
        numero_tarefas_concluidas: 'Nombre de tâches terminées',
        conluida_depois: 'Nombre de tâches terminées après l\'échéance',
        atrasado: 'En retard de',
        dia: 'jour',
        menos_1dia: 'Moins d\'un jour',
        tarefa_modal: 'Tâche : ',
        tarefa_calendario: 'Tâche :',
        stats_of: 'Statistiques de',
        notifications: 'Notifications',
        notifications_list: 'Toutes les notifications',
        notifications_empty: 'Aucune notification',
        masculino: 'Masculino',
        feminino: 'Feminino',
        outros: 'Outros'
    }
}

module.exports = {
    language
};